// CosmicMatch USA Production Bundle
;
/**
 * CosmicMatch USA - US States Geographical and Astrological Metadata
 * This file is automatically generated and contains all 50 states, their abbreviations, 
 * capitals, and SVG paths for high-quality interactive vector map rendering.
 */

const US_STATES_DATA = {
  "AL": {
    "id": "AL",
    "name": "Alabama",
    "capital": "Montgomery",
    "path": "M799.6,566.8l-1.6-15.2l-2.7-18.8l0.2-14.1l0.8-31l-0.2-16.7l0.2-6.4l7.8-0.4l27.8-2.6l8.9-0.7 l-0.1,2.2l0.2,2.1l0.6,3.4l3.4,7.9l2.4,9.9l1.5,6.1l1.6,4.8l1.5,7l2.1,6.3l2.6,3.4l0.5,3.4l1.9,0.8l0.2,2.1l-1.8,4.8l-0.5,3.2 l-0.2,1.9l1.6,4.4l0.3,5.3l-0.8,2.4l0.6,0.8l1.5,0.8l1,2.5h-6.3l-6.8,0.6l-25.5,2.9l-10.4,1.4l-0.1,3.8l1.8,1.8l2.6,1.9l0.6,7.9 l-5.5,2.6l-2.7-0.3l2.7-1.9v-1l-3.1-6l-2.3-0.6l-1.5,4.4l-1.3,2.7l-0.6-0.2H799.6z"
  },
  "AK": {
    "id": "AK",
    "name": "Alaska",
    "capital": "Juneau",
    "path": "M332.1,553.7l-0.3,85.4l1.6,1l3.1,0.2l1.5-1.1h2.6l0.2,2.9l7,6.8l0.5,2.6l3.4-1.9l0.6-0.2l0.3-3.1 l1.5-1.6l1.1-0.2l1.9-1.5l3.1,2.1l0.6,2.9l1.9,1.1l1.1,2.4l3.9,1.8l3.4,6l2.7,3.9l2.3,2.7l1.5,3.7l5,1.8l5.2,2.1l1,4.4l0.5,3.1 l-1,3.4l-1.8,2.3l-1.6-0.8l-1.5-3.1l-2.7-1.5l-1.8-1.1l-0.8,0.8l1.5,2.7l0.2,3.7l-1.1,0.5l-1.9-1.9l-2.1-1.3l0.5,1.6l1.3,1.8 l-0.8,0.8c0,0-0.8-0.3-1.3-1c-0.5-0.6-2.1-3.4-2.1-3.4l-1-2.3c0,0-0.3,1.3-1,1c-0.6-0.3-1.3-1.5-1.3-1.5l1.8-1.9l-1.5-1.5v-5h-0.8 l-0.8,3.4l-1.1,0.5l-1-3.7l-0.6-3.7l-0.8-0.5l0.3,5.7v1.1l-1.5-1.3l-3.6-6l-2.1-0.5l-0.6-3.7l-1.6-2.9l-1.6-1.1v-2.3l2.1-1.3 l-0.5-0.3l-2.6,0.6l-3.4-2.4l-2.6-2.9l-4.8-2.6l-4-2.6l1.3-3.2v-1.6l-1.8,1.6l-2.9,1.1l-3.7-1.1l-5.7-2.4h-5.5l-0.6,0.5l-6.5-3.9 l-2.1-0.3l-2.7-5.8l-3.6,0.3l-3.6,1.5l0.5,4.5l1.1-2.9l1,0.3l-1.5,4.4l3.2-2.7l0.6,1.6l-3.9,4.4l-1.3-0.3l-0.5-1.9l-1.3-0.8 l-1.3,1.1l-2.7-1.8l-3.1,2.1l-1.8,2.1l-3.4,2.1l-4.7-0.2l-0.5-2.1l3.7-0.6v-1.3l-2.3-0.6l1-2.4l2.3-3.9v-1.8l0.2-0.8l4.4-2.3l1,1.3 h2.7l-1.3-2.6l-3.7-0.3l-5,2.7l-2.4,3.4l-1.8,2.6l-1.1,2.3l-4.2,1.5l-3.1,2.6l-0.3,1.6l2.3,1l0.8,2.1l-2.7,3.2l-6.5,4.2l-7.8,4.2 l-2.1,1.1l-5.3,1.1l-5.3,2.3l1.8,1.3l-1.5,1.5l-0.5,1.1l-2.7-1l-3.2,0.2l-0.8,2.3h-1l0.3-2.4l-3.6,1.3l-2.9,1l-3.4-1.3l-2.9,1.9 h-3.2l-2.1,1.3l-1.6,0.8l-2.1-0.3l-2.6-1.1l-2.3,0.6l-1,1l-1.6-1.1v-1.9l3.1-1.3l6.3,0.6l4.4-1.6l2.1-2.1l2.9-0.6l1.8-0.8l2.7,0.2 l1.6,1.3l1-0.3l2.3-2.7l3.1-1l3.4-0.6l1.3-0.3l0.6,0.5h0.8l1.3-3.7l4-1.5l1.9-3.7l2.3-4.5l1.6-1.5l0.3-2.6l-1.6,1.3l-3.4,0.6 l-0.6-2.4l-1.3-0.3l-1,1l-0.2,2.9l-1.5-0.2l-1.5-5.8l-1.3,1.3l-1.1-0.5l-0.3-1.9l-4,0.2l-2.1,1.1l-2.6-0.3l1.5-1.5l0.5-2.6 l-0.6-1.9l1.5-1l1.3-0.2l-0.6-1.8v-4.4l-1-1l-0.8,1.5h-6.1l-1.5-1.3l-0.6-3.9l-2.1-3.6v-1l2.1-0.8l0.2-2.1l1.1-1.1l-0.8-0.5 l-1.3,0.5l-1.1-2.7l1-5l4.5-3.2l2.6-1.6l1.9-3.7l2.7-1.3l2.6,1.1l0.3,2.4l2.4-0.3l3.2-2.4l1.6,0.6l1,0.6h1.6l2.3-1.3l0.8-4.4 c0,0,0.3-2.9,1-3.4c0.6-0.5,1-1,1-1l-1.1-1.9l-2.6,0.8l-3.2,0.8l-1.9-0.5l-3.6-1.8l-5-0.2l-3.6-3.7l0.5-3.9l0.6-2.4l-2.1-1.8 l-1.9-3.7l0.5-0.8l6.8-0.5h2.1l1,1h0.6l-0.2-1.6l3.9-0.6l2.6,0.3l1.5,1.1l-1.5,2.1l-0.5,1.5l2.7,1.6l5,1.8l1.8-1l-2.3-4.4l-1-3.2 l1-0.8l-3.4-1.9l-0.5-1.1l0.5-1.6l-0.8-3.9l-2.9-4.7l-2.4-4.2l2.9-1.9h3.2l1.8,0.6l4.2-0.2l3.7-3.6l1.1-3.1l3.7-2.4l1.6,1l2.7-0.6 l3.7-2.1l1.1-0.2l1,0.8l4.5-0.2l2.7-3.1h1.1l3.6,2.4l1.9,2.1l-0.5,1.1l0.6,1.1l1.6-1.6l3.9,0.3l0.3,3.7l1.9,1.5l7.1,0.6l6.3,4.2 l1.5-1l5.2,2.6l2.1-0.6l1.9-0.8l4.8,1.9L332.1,553.7z M217,582.6l2.1,5.3l-0.2,1l-2.9-0.3l-1.8-4l-1.8-1.5H210l-0.2-2.6l1.8-2.4 l1.1,2.4l1.5,1.5L217,582.6z M214.4,616.1l3.7,0.8l3.7,1l0.8,1l-1.6,3.7l-3.1-0.2l-3.4-3.6L214.4,616.1z M193.7,602l1.1,2.6 l1.1,1.6l-1.1,0.8l-2.1-3.1V602H193.7z M180,675.1l3.4-2.3l3.4-1l2.6,0.3l0.5,1.6l1.9,0.5l1.9-1.9l-0.3-1.6l2.7-0.6l2.9,2.6 l-1.1,1.8l-4.4,1.1l-2.7-0.5l-3.7-1.1l-4.4,1.5l-1.6,0.3L180,675.1z M228.9,670.6l1.6,1.9l2.1-1.6l-1.5-1.3L228.9,670.6z M231.8,673.6l1.1-2.3l2.1,0.3l-0.8,1.9H231.8z M255.4,671.7l1.5,1.8l1-1.1l-0.8-1.9L255.4,671.7z M264.2,659.2l1.1,5.8l2.9,0.8 l5-2.9l4.4-2.6l-1.6-2.4l0.5-2.4l-2.1,1.3l-2.9-0.8l1.6-1.1l1.9,0.8l3.9-1.8l0.5-1.5l-2.4-0.8l0.8-1.9l-2.7,1.9l-4.7,3.6l-4.8,2.9 L264.2,659.2z M306.5,639.4l2.4-1.5l-1-1.8l-1.8,1L306.5,639.4z"
  },
  "AZ": {
    "id": "AZ",
    "name": "Arizona",
    "capital": "Phoenix",
    "path": "M311.7,487.5l-2.6,2.2l-0.3,1.5l0.5,1l18.9,10.7l12.1,7.6l14.7,8.6l16.8,10l12.3,2.4l25.1,2.7 l2.5-12.5l3.8-27.2l7-52.9l4.3-31l-24.6-3.7l-27.2-4.6l-33.4-6.3l-2.9,18.1l-0.5,0.5l-1.7,2.6l-2.5-0.1l-1.3-2.7l-2.7-0.3l-0.9-1.1 h-0.9l-0.9,0.6l-1.9,1l-0.1,7l-0.2,1.7l-0.6,12.6l-1.5,2.2l-0.6,3.3l2.7,4.9l1.3,5.8l0.8,1l1,0.6l-0.1,2.3l-1.6,1.4l-3.4,1.7 l-1.9,1.9l-1.5,3.7l-0.6,4.9l-2.9,2.7l-2.1,0.7l-0.1,5.8l-0.5,1.7l0.5,0.8l3.7,0.6l-0.6,2.7l-1.5,2.2L311.7,487.5z"
  },
  "AR": {
    "id": "AR",
    "name": "Arkansas",
    "capital": "Little Rock",
    "path": "M765,445l-3.8,0.9l-6.2-0.5l0.7-3l3.2-2.7l0.5-2.3l-1.8-3l-11,0.5l-20.8,0.9l-23.3,0.7L679,437 l1.6,6.9v8.2l1.4,11l0.2,37.8l2.3,1.9l3-1.4l2.7,1.1l0.4,10.3l22.9-0.1l18.9-0.8l10.1-0.2l1.1-2.1l-0.3-3.5l-1.8-3l1.6-1.5 l-1.6-2.5l0.7-2.5l1.4-5.6l2.5-2.1l-0.7-2.3l3.7-5.4l2.7-1.4l-0.1-1.5l-0.3-1.8l2.9-5.6l2.4-1.3l0.4-3.4l1.8-1.2l0.9-4.2l-1.3-4 l4-2.4l0.6-2l1.2-4.3L765,445z"
  },
  "CA": {
    "id": "CA",
    "name": "California",
    "capital": "Sacramento",
    "path": "M310.7,486.8l3.8-0.5l1.5-2l0.7-1.9l-3.2-0.1l-1.1-1.8l0.8-1.7l0-6.2l2.2-1.3l2.7-2.6l0.4-4.9 l1.6-3.5l1.9-2.1l3.3-1.7l1.3-0.7l0.8-1.5l-0.9-0.9l-1-1.5l-0.9-5.3l-2.9-5.2l0.1-2.8l-2.2-3.2l-15-23.2l-19.4-28.7l-22.4-33 l-12.7-19.5l1.8-7.2l6.8-25.9l8.1-31.4l-12.4-3.3l-13.5-3.4l-12.6-4.1l-7.5-2.1l-11.4-3l-7.1-2.4l-1.6,4.7l-0.2,7.4l-5.2,11.8 l-3.1,2.6l-0.3,1.1l-1.8,0.8l-1.5,4.2l-0.8,3.2l2.7,4.2l1.6,4.2l1.1,3.6l-0.3,6.5l-1.8,3.1l-0.6,5.8l-1,3.7l1.8,3.9l2.7,4.5 l2.3,4.8l1.3,4l-0.3,3.2l-0.3,0.5v2.1l5.7,6.3l-0.5,2.4l-0.6,2.3l-0.6,1.9l0.2,8.2l2.1,3.7l1.9,2.6l2.7,0.5l1,2.7l-1.1,3.6 l-2.1,1.6h-1.1l-0.8,3.9l0.5,2.9l3.2,4.4l1.6,5.3l1.5,4.7l1.3,3.1l3.4,5.8l1.5,2.6l0.5,2.9l1.6,1v2.4l-0.8,1.9l-1.8,7.1l-0.5,1.9 l2.4,2.7l4.2,0.5l4.5,1.8l3.9,2.1h2.9l2.9,3.1l2.6,4.8l1.1,2.3l3.9,2.1l4.8,0.8l1.5,2.1l0.6,3.2l-1.5,0.6l0.3,1l3.2,0.8l2.7,0.2 l2.9,4.7l3.9,4.2l0.8,2.3l2.6,4.2l0.3,3.2v9.4l0.5,1.8l10,1.5l19.7,2.7L310.7,486.8z M222.8,437l1.3,1.5l-0.2,1.3l-3.2-0.1 l-0.6-1.2l-0.6-1.5L222.8,437z M224.7,437l1.2-0.6l3.6,2.1l3.1,1.2l-0.9,0.6l-4.5-0.2l-1.6-1.6L224.7,437z M245.4,456.8l1.8,2.3 l0.8,1l1.5,0.6l0.6-1.5l-1-1.8l-2.7-2l-1.1,0.2V456.8z M244,465.5l1.8,3.2l1.2,1.9l-1.5,0.2l-1.3-1.2c0,0-0.7-1.5-0.7-1.9 s0-2.2,0-2.2L244,465.5z"
  },
  "CO": {
    "id": "CO",
    "name": "Colorado",
    "capital": "Denver",
    "path": "M552.6,356.8l1.4-21.3l-32.1-3.1l-24.5-2.7l-37.3-4.1l-20.7-2.5l-2.6,22.2l-3.2,22.4l-3.8,28 l-1.5,11.1l-0.3,2.8l33.9,3.8l37.7,4.3l32,3.2l16.6,0.8"
  },
  "CT": {
    "id": "CT",
    "name": "Connecticut",
    "capital": "Hartford",
    "path": "M1047.2,280.1l-0.6-4.2l-0.8-4.4l-1.6-6l-4.2,0.9l-21.8,4.8l0.6,3.3l1.5,7.3v8.1l-1.1,2.3l1.8,2.1 l5-3.4l3.6-3.2l1.9-2.1l0.8,0.6l2.7-1.5l5.2-1.1L1047.2,280.1z"
  },
  "DE": {
    "id": "DE",
    "name": "Delaware",
    "capital": "Dover",
    "path": "M996.4,330.4l0.6-2.1l0-1.2l-1.3-0.1l-2.1,1.6l-1.5,1.5l1.5,4.2l2.3,5.7l2.1,9.7l1.6,6.3l5-0.2 l6.1-1.2l-2.3-7.4l-1,0.5l-3.6-2.4l-1.8-4.7l-1.9-3.6l-2.3-1l-2.1-3.6L996.4,330.4z"
  },
  "FL": {
    "id": "FL",
    "name": "Florida",
    "capital": "Tallahassee",
    "path": "M929.4,545.5l2.3,7.3l3.7,9.7l5.3,9.4l3.7,6.3l4.8,5.5l4,3.7l1.6,2.9l-1.1,1.3L953,593l2.9,7.4 l2.9,2.9l2.6,5.3l3.6,5.8l4.5,8.2l1.3,7.6l0.5,12l0.6,1.8l-0.3,3.4l-2.4,1.3l0.3,1.9l-0.6,1.9l0.3,2.4l0.5,1.9l-2.7,3.2l-3.1,1.5 l-3.9,0.2l-1.5,1.6l-2.4,1l-1.3-0.5l-1.1-1l-0.3-2.9l-0.8-3.4l-3.4-5.2l-3.6-2.3l-3.9-0.3l-0.8,1.3l-3.1-4.4l-0.6-3.6l-2.6-4 l-1.8-1.1l-1.6,2.1l-1.8-0.3l-2.1-5l-2.9-3.9l-2.9-5.3l-2.6-3.1l-3.6-3.7l2.1-2.4l3.2-5.5l-0.2-1.6l-4.5-1l-1.6,0.6l0.3,0.6l2.6,1 l-1.5,4.5l-0.8,0.5l-1.8-4l-1.3-4.8l-0.3-2.7l1.5-4.7v-9.5L910,585l-1.3-3.1l-5.2-1.3l-1.9-0.6l-1.6-2.6l-3.4-1.6l-1.1-3.4l-2.7-1 l-2.4-3.7l-4.2-1.5l-2.9-1.5h-2.6l-4,0.8l-0.2,1.9l0.8,1l-0.5,1.1l-3.1-0.2l-3.7,3.6l-3.6,1.9h-3.9l-3.2,1.3l-0.3-2.7l-1.6-1.9 l-2.9-1.1l-1.6-1.5l-8.1-3.9l-7.6-1.8l-4.4,0.6l-6,0.5l-6,2.1l-3.5,0.6l-0.2-8l-2.6-1.9l-1.8-1.8l0.3-3.1l10.2-1.3l25.5-2.9 l6.8-0.6l5.4,0.3l2.6,3.9l1.5,1.5l8.1,0.5l10.8-0.6l21.5-1.3l5.4-0.7l4.6,0l0.2,2.9l3.8,0.8l0.3-4.8l-1.6-4.5l1-0.7l5.1,0.5 L929.4,545.5z M941.9,677.9l2.4-0.6l1.3-0.2l1.5-2.3l2.3-1.6l1.3,0.5l1.7,0.3l0.4,1.1l-3.5,1.2l-4.2,1.5l-2.3,1.2L941.9,677.9z M955.4,672.9l1.2,1.1l2.7-2.1l5.3-4.2l3.7-3.9l2.5-6.6l1-1.7l0.2-3.4l-0.7,0.5l-1,2.8l-1.5,4.6l-3.2,5.3l-4.4,4.2l-3.4,1.9 L955.4,672.9z"
  },
  "GA": {
    "id": "GA",
    "name": "Georgia",
    "capital": "Atlanta",
    "path": "M863.6,458l-4.8,0.8l-8.4,1.1l-8.6,0.9v2.2l0.2,2.1l0.6,3.4l3.4,7.9l2.4,9.9l1.5,6.1l1.6,4.8l1.5,7 l2.1,6.3l2.6,3.4l0.5,3.4l1.9,0.8l0.2,2.1l-1.8,4.8l-0.5,3.2l-0.2,1.9l1.6,4.4l0.3,5.3l-0.8,2.4l0.6,0.8l1.5,0.8l0.6,3.4l2.6,3.9 l1.5,1.5l7.9,0.2l10.8-0.6l21.5-1.3l5.4-0.7l4.6,0l0.2,2.9l2.6,0.8l0.3-4.4l-1.6-4.5l1.1-1.6l5.8,0.8l5,0.3l-0.8-6.3l2.3-10 l1.5-4.2l-0.5-2.6l3.3-6.2l-0.5-1.4l-1.9,0.7l-2.6-1.3l-0.6-2.1l-1.3-3.6l-2.3-2.1l-2.6-0.6l-1.6-4.8l-2.9-6.3l-4.2-1.9l-2.1-1.9 l-1.3-2.6l-2.1-1.9l-2.3-1.3l-2.3-2.9l-3.1-2.3l-4.5-1.8l-0.5-1.5l-2.4-2.9l-0.5-1.5l-3.4-4.9l-3.4,0.2l-4.1-3l-1.3-1.3l-0.3-1.8 l0.8-1.9l2.4-1.2l-1.1-1.2l0.1-0.3l-5.8,1l-7,0.8L863.6,458z"
  },
  "HI": {
    "id": "HI",
    "name": "Hawaii",
    "capital": "Honolulu",
    "path": "M407.1,619.3l1.9-3.6l2.3-0.3l0.3,0.8l-2.1,3.1H407.1z M417.3,615.6l6.1,2.6l2.1-0.3l1.6-3.9 l-0.6-3.4l-4.2-0.5l-4,1.8L417.3,615.6z M448,625.6l3.7,5.5l2.4-0.3l1.1-0.5l1.5,1.3l3.7-0.2l1-1.5l-2.9-1.8l-1.9-3.7l-2.1-3.6 l-5.8,2.9L448,625.6z M468.2,634.5l1.3-1.9l4.7,1l0.6-0.5l6.1,0.6l-0.3,1.3l-2.6,1.5l-4.4-0.3L468.2,634.5z M473.5,639.7l1.9,3.9 l3.1-1.1l0.3-1.6l-1.6-2.1l-3.7-0.3V639.7z M480.5,638.5l2.3-2.9l4.7,2.4l4.4,1.1l4.4,2.7v1.9l-3.6,1.8l-4.8,1l-2.4-1.5 L480.5,638.5z M497.1,654.1l1.6-1.3l3.4,1.6l7.6,3.6l3.4,2.1l1.6,2.4l1.9,4.4l4,2.6l-0.3,1.3l-3.9,3.2l-4.2,1.5l-1.5-0.6l-3.1,1.8 l-2.4,3.2l-2.3,2.9l-1.8-0.2l-3.6-2.6l-0.3-4.5l0.6-2.4l-1.6-5.7l-2.1-1.8l-0.2-2.6l2.3-1l2.1-3.1l0.5-1l-1.6-1.8L497.1,654.1z"
  },
  "ID": {
    "id": "ID",
    "name": "Idaho",
    "capital": "Boise",
    "path": "M336.1,281c-22.6-4.3-14.1-2.8-21.1-4.4l4.4-17.5l4.3-17.7l1.4-4.2l2.5-5.9l-1.3-2.3l-2.5,0.1 l-0.8-1l0.5-1.1l0.3-3.1l4.5-5.5l1.8-0.5l1.1-1.1l0.6-3.2l0.9-0.7l3.9-5.8l3.9-4.3l0.2-3.8l-3.4-2.6l-1.3-4.4l0.4-9.7l3.7-16.5 l4.5-20.8l3.8-13.5l0.8-3.8l13,2.5l-4.2,21.5l2.9,7.7l-1.1,4.6l2,4.6l3.2,1.7l4.5,9.8l2.7,3.8l0.6,1.1l3.4,1.1l0.5,2.5l-6.9,16.8 l0.3,3.3l2.7,2.9l1.9,0.5l4.8-3.6l0.4-0.5l0.2,0.8l0.3,4.1l2.6,12.9l3.5,2.7l0.4,0.8l2.1,2.4l-0.8,2.8l0.7,3.8l1.9,0.9l2.1-1.6 l2.6-0.5l3.4,1.6l2.5-0.6l3.8-0.2l4,1.6l2.7-0.3l0.9-2.3l2.5-1.6l0.7,1.7l0.6,2.2l2.3,2.5l-3.8,24l-5.1,29l-4.2-0.3l-8.2-1.5 l-9.8-1.8l-12.2-2.4l-12.5-2.5l-8.5-1.8l-9.3-1.7L336.1,281z"
  },
  "IL": {
    "id": "IL",
    "name": "Illinois",
    "capital": "Springfield",
    "path": "M791.8,401.6V398l0.3-4.9l2.4-3.1l1.8-3.8l2.6-3.9l-0.4-5.3l-2-3.5l-0.1-3.3l0.7-5.3l-0.8-7.2 l-1.1-15.8l-1.3-15l-0.9-11.6l-0.3-0.9l-0.8-2.6l-1.3-3.7l-1.6-1.8l-1.5-2.6l-0.2-5.5l-9.9,1.3l-27.2,1.7l-8.7-0.4l0.2,2.4l2.3,0.7 l0.9,1.1l0.5,1.8l3.9,3.4l0.7,2.3l-0.7,3.4l-1.8,3.7l-0.7,2.5l-2.3,1.8l-1.8,0.7l-5.3,1.4l-0.7,1.8L736,330l0.7,1.4l1.8,1.6 l-0.2,4.1l-1.8,1.6l-0.7,1.6v2.7l-1.8,0.5l-1.6,1.1l-0.2,1.4l0.2,2.1l-1.7,1.3l-1,2.8l0.5,3.7l2.3,7.3l7.3,7.5l5.5,3.7l-0.2,4.3 l0.9,1.4l6.4,0.5l2.7,1.4l-0.7,3.7l-2.3,5.9l-0.7,3.2l2.3,3.9l6.4,5.3l4.6,0.7l2.1,5l2.1,3.2l-0.9,3l1.6,4.1l1.8,2.1l1.9-0.8 l0.7-2.2l2-1.4l3.2-1.1l3.1,1.2l2.9,1.1l0.8-0.2l-0.1-1.2l-1.1-2.8l0.4-2.4l2.3-1.6l2.4-1l1.2-0.4l-0.6-1.3l-0.8-2.2l1.2-1.3 L791.8,401.6z"
  },
  "IN": {
    "id": "IN",
    "name": "Indiana",
    "capital": "Indianapolis",
    "path": "M792.4,400.9l0.1-2.9l0.5-4.5l2.3-2.9l1.8-3.9l2.6-4.2l-0.5-5.8l-1.8-2.7l-0.3-3.2l0.8-5.5l-0.5-7 l-1.3-16l-1.3-15.4l-1-11.7l3.1,0.9l1.5,1l1.1-0.3l2.1-1.9l2.8-1.6l5.1-0.2l22-2.3l5.6-0.5l1.5,16l4.3,36.8l0.6,5.8L843,371 l1.2,1.8l0.1,1.4l-2.5,1.6l-3.5,1.6l-3.2,0.6l-0.6,4.9l-4.6,3.3l-2.8,4l0.3,2.4l-0.6,1.5h-3.3l-1.6-1.6l-2.5,1.3l-2.7,1.5l0.2,3.1 l-1.2,0.3l-0.5-1l-2.2-1.5l-3.3,1.3l-1.6,3l-1.4-0.8l-1.5-1.6l-4.5,0.5l-5.6,1L792.4,400.9z"
  },
  "IA": {
    "id": "IA",
    "name": "Iowa",
    "capital": "Des Moines",
    "path": "M740.6,301.6l0.2,1.9l2.3,1.1l1.1,1.3l0.3,1.3l3.9,3.2l0.7,2.2l-0.8,2.9l-1.5,3.5l-0.8,2.7 l-2.2,1.6l-1.7,0.6l-5.5,1.5l-0.7,2.3l-0.8,2.3l0.6,1.4l1.7,1.7l0,3.7l-2.2,1.6l-0.5,1.5v2.5l-1.5,0.5l-1.7,1.4l-0.5,1.5l0.5,1.7 l-1.4,1.2l-2.3-2.7l-1.5-2.6l-8.3,0.8l-10.2,0.6l-25,0.7l-13,0.2l-9.4,0.2l-1.3,0.1l-1.7-4.5l-0.2-6.6l-1.6-4.1l-0.7-5.3l-2.3-3.7 l-0.9-4.8l-2.7-7.5l-1.1-5.4l-1.4-2.2l-1.6-2.7l1.8-4.3l1.4-5.7l-2.7-2.1l-0.5-2.7l0.9-2.5h1.7h11.5l49.6-0.7l19.9-0.7l1.9,2.7 l1.8,2.6l0.5,0.8l-1.8,2.7l0.5,4.2l2.5,3.9l3,1.8l2.4,0.2L740.6,301.6z"
  },
  "KS": {
    "id": "KS",
    "name": "Kansas",
    "capital": "Topeka",
    "path": "M677.4,425.1l-12.6,0.2l-46.1-0.5l-44.6-2.1l-24.6-1.3l4.1-64.7l21.8,0.8l40.5,1.4l44.1,0.5h5.1 l3.2,3.2l2.8,0.2l0.9,1.1v2l-1.8,1.6l-0.5,2.6l2.2,3.6l2.5,3.1l2.5,2l1.1,11.2L677.4,425.1z"
  },
  "KY": {
    "id": "KY",
    "name": "Kentucky",
    "capital": "Frankfort",
    "path": "M895.8,397.8l-2.3,2.7l-4.2,3.6L885,410l-1.8,1.8v2.1l-3.9,2.1l-5.7,3.4l-3.5,0.4l-51.9,4.9 l-15.8,1.8l-4.6,0.5l-3.9,0l-0.2,4.2l-8.2,0.1l-7,0.6l-10.4,0.2l1.9-0.2l2.2-1.8l2.1-1.1l0.2-3.2l0.9-1.8l-1.6-2.5l0.8-1.9l2.3-1.8 l2.1-0.6l2.7,1.3l3.6,1.3l1.1-0.3l0.2-2.3l-1.3-2.4l0.3-2.3l1.9-1.5l2.6-0.6l1.6-0.6l-0.8-1.8l-0.6-1.9l1.1-0.8l1.1-3.3l3-1.7 l5.8-1l3.6-0.5l1.5,1.9l1.8,0.8l1.8-3.2l2.9-1.5l1.9,1.6l0.8,1.1l2.1-0.5l-0.2-3.4l2.9-1.6l1.1-0.8l1.1,1.6h4.7l0.8-2.1l-0.3-2.3 l2.9-3.6l4.7-3.9l0.5-4.5l2.7-0.3l3.9-1.8l2.7-1.9l-0.3-1.9l-1.5-1.5l0.6-2.2l4.1-0.2l2.4-0.8l2.9,1.6l1.6,4.4l5.8,0.3l1.8,1.8 l2.1,0.2l2.4-1.5l3.1,0.5l1.3,1.5l2.7-2.6l1.8-1.3h1.6l0.6,2.7l1.8,1l2.4,2.2l0.2,5.5l0.8,1.6l2.6,1.5l0.6,2.3l2.9,3.7l2.6,2.7 L895.8,397.8z"
  },
  "LA": {
    "id": "LA",
    "name": "Louisiana",
    "capital": "Baton Rouge",
    "path": "M776.2,573l-1-2.6l-1.1-3.1l-3.3-3.5l0.9-6.8l-0.1-1.1l-1.3,0.3l-8.2,0.9l-25,0.5l-0.7-2.4l0.9-8.5 l3.3-5.9l5-8.7l-0.6-2.4l1.3-0.7l0.5-2l-2.3-2.1l-0.1-1.9l-1.8-4.3l-0.5-5.9l-9.7,0.1l-19.2,0.9l-22.2,0l0,9.6l0.7,9.4l0.7,3.9 l2.5,4.1l0.9,5l4.3,5.5l0.2,3.2l0.7,0.7l-0.7,8.5l-3,5l1.6,2.1l-0.7,2.5l-0.7,7.3l-1.4,3.2l0.1,3.6l4.7-1.5l8.1-0.3l10.3,3.6 l6.5,1.1l3.7-1.5l3.2,1.1l3.2,1l0.8-2.1l-3.2-1.1l-2.6,0.5l-2.7-1.6c0,0,0.2-1.3,0.8-1.5c0.6-0.2,3.1-1,3.1-1l1.8,1.5l1.8-1 l3.2,0.6l1.5,2.4l0.3,2.3l4.5,0.3l1.8,1.8l-0.8,1.6l-1.3,0.8l1.6,1.6l8.4,3.6l3.6-1.3l1-2.4l2.6-0.6l1.8-1.5l1.3,1l0.8,2.9 l-2.3,0.8l0.6,0.6l3.4-1.3l2.3-3.4l0.8-0.5l-2.1-0.3l0.8-1.6l-0.2-1.5l2.1-0.5l1.1-1.3l0.6,0.8c0,0-0.2,3.1,0.6,3.1 c0.8,0,4.2,0.6,4.2,0.6l4,1.9l1,1.5h2.9l1.1,1l2.3-3.1v-1.5h-1.3l-3.4-2.7l-5.8-0.8l-3.2-2.3l1.1-2.7l2.3,0.3l0.2-0.6l-1.8-1v-0.5 h3.2l1.8-3.1l-1.3-1.9l-0.3-2.7l-1.5,0.2l-1.9,2.1l-0.6,2.6l-3.1-0.6l-1-1.8l1.8-1.9l2-1.8L776.2,573z"
  },
  "ME": {
    "id": "ME",
    "name": "Maine",
    "capital": "Augusta",
    "path": "M1097.2,177.3l1.9,2.1l2.3,3.7v1.9l-2.1,4.7l-1.9,0.6l-3.4,3.1l-4.8,5.5c0,0-0.6,0-1.3,0 c-0.6,0-1-2.1-1-2.1l-1.8,0.2l-1,1.5l-2.4,1.5l-1,1.5l1.6,1.5l-0.5,0.6l-0.5,2.7l-1.9-0.2v-1.6l-0.3-1.3l-1.5,0.3l-1.8-3.2 l-2.1,1.3l1.3,1.5l0.3,1.1l-0.8,1.3l0.3,3.1l0.2,1.6l-1.6,2.6l-2.9,0.5l-0.3,2.9l-5.3,3.1l-1.3,0.5l-1.6-1.5l-3.1,3.6l1,3.2 l-1.5,1.3l-0.2,4.4l-1.1,6.3l-2.5-1.2l-0.5-3.1l-3.9-1.1l-0.3-2.7l-7.3-23.4l-4.2-13.6l1.4-0.1l1.5,0.4v-2.6l0.8-5.5l2.6-4.7l1.5-4 l-1.9-2.4v-6l0.8-1l0.8-2.7l-0.2-1.5l-0.2-4.8l1.8-4.8l2.9-8.9l2.1-4.2h1.3l1.3,0.2v1.1l1.3,2.3l2.7,0.6l0.8-0.8v-1l4-2.9l1.8-1.8 l1.5,0.2l6,2.4l1.9,1l9.1,29.9h6l0.8,1.9l0.2,4.8l2.9,2.3h0.8l0.2-0.5l-0.5-1.1L1097.2,177.3z M1076.3,207.5l1.5-1.5l1.4,1.1 l0.6,2.4l-1.7,0.9L1076.3,207.5z M1083,201.6l1.8,1.9c0,0,1.3,0.1,1.3-0.2s0.2-2,0.2-2l0.9-0.8l-0.8-1.8l-2,0.7L1083,201.6z"
  },
  "MD": {
    "id": "MD",
    "name": "Maryland",
    "capital": "Annapolis",
    "path": "M1011,355.3l-6.1,1.3l-5.8,0.2l-1.8-7.1l-2.1-9.7l-2.3-5.7l-1.3-4.4l-7.5,1.6l-14.9,2.8l-37.5,7.6 l1.1,5l1,5.7l0.3-0.3l2.1-2.4l2.3-2.6l2.4-0.6l1.5-1.5l1.8-2.6l1.3,0.6l2.9-0.3l2.6-2.1l2-1.5l1.8-0.5l1.6,1.1l2.9,1.5l1.9,1.8 l1.2,1.5l4.1,1.7v2.9l5.5,1.3l1.1,0.5l1.4-2l2.9,2l-1.3,2.5l-0.8,4l-1.8,2.6v2.1l0.6,1.8l5.1,1.4l4.3-0.1l3.1,1l2.1,0.3l1-2.1 l-1.5-2.1v-1.8l-2.4-2.1l-2.1-5.5l1.3-5.3l-0.2-2.1l-1.3-1.3c0,0,1.5-1.6,1.5-2.3c0-0.6,0.5-2.1,0.5-2.1l1.9-1.3l1.9-1.6l0.5,1 l-1.5,1.6l-1.3,3.7l0.3,1.1l1.8,0.3l0.5,5.5l-2.1,1l0.3,3.6l0.5-0.2l1.1-1.9l1.6,1.8l-1.6,1.3l-0.3,3.4l2.6,3.4l3.9,0.5l1.6-0.8 l3.2,4.2l1.4,0.5l6.7-2.8l2-4L1011,355.3z M994.3,364.3l1.1,2.5l0.2,1.8l1.1,1.9c0,0,0.9-0.9,0.9-1.2c0-0.3-0.7-3.1-0.7-3.1 l-0.7-2.3L994.3,364.3z"
  },
  "MA": {
    "id": "MA",
    "name": "Massachusetts",
    "capital": "Boston",
    "path": "M1074,273.9l2.2-0.7l0.5-1.7l1,0.1l1,2.3l-1.3,0.5l-3.9,0.1L1074,273.9z M1064.6,274.7l2.3-2.6h1.6 l1.8,1.5l-2.4,1l-2.2,1L1064.6,274.7z M1029.8,252.7l17.5-4.2l2.3-0.6l2.1-3.2l3.7-1.7l2.9,4.4l-2.4,5.2l-0.3,1.5l1.9,2.6l1.1-0.8 h1.8l2.3,2.6l3.9,6l3.6,0.5l2.3-1l1.8-1.8l-0.8-2.7l-2.1-1.6l-1.5,0.8l-1-1.3l0.5-0.5l2.1-0.2l1.8,0.8l1.9,2.4l1,2.9l0.3,2.4 l-4.2,1.5l-3.9,1.9l-3.9,4.5l-1.9,1.5v-1l2.4-1.5l0.5-1.8l-0.8-3.1l-2.9,1.5l-0.8,1.5l0.5,2.3l-2.1,1l-2.7-4.5l-3.4-4.4l-2.1-1.8 l-6.5,1.9l-5.1,1.1l-21.8,4.8l-0.4-4.9l0.6-10.6l5.2-0.9L1029.8,252.7z"
  },
  "MI": {
    "id": "MI",
    "name": "Michigan",
    "capital": "Lansing",
    "path": "M755.6,182.1l1.8-2.1l2.2-0.8l5.4-3.9l2.3-0.6l0.5,0.5l-5.1,5.1l-3.3,1.9l-2.1,0.9L755.6,182.1z M841.8,214.2l0.6,2.5l3.2,0.2l1.3-1.2c0,0-0.1-1.5-0.4-1.6c-0.3-0.2-1.6-1.9-1.6-1.9l-2.2,0.2l-1.6,0.2l-0.3,1.1L841.8,214.2z M871.9,277.2l-3.2-8.2l-2.3-9.1l-2.4-3.2l-2.6-1.8l-1.6,1.1l-3.9,1.8l-1.9,5l-2.7,3.7l-1.1,0.6l-1.5-0.6c0,0-2.6-1.5-2.4-2.1 c0.2-0.6,0.5-5,0.5-5l3.4-1.3l0.8-3.4l0.6-2.6l2.4-1.6l-0.3-10l-1.6-2.3l-1.3-0.8l-0.8-2.1l0.8-0.8l1.6,0.3l0.2-1.6L850,231 l-1.3-2.6h-2.6l-4.5-1.5l-5.5-3.4h-2.7l-0.6,0.6l-1-0.5l-3.1-2.3l-2.9,1.8l-2.9,2.3l0.3,3.6l1,0.3l2.1,0.5l0.5,0.8l-2.6,0.8 l-2.6,0.3l-1.5,1.8l-0.3,2.1l0.3,1.6l0.3,5.5l-3.6,2.1l-0.6-0.2v-4.2l1.3-2.4l0.6-2.4l-0.8-0.8l-1.9,0.8l-1,4.2l-2.7,1.1l-1.8,1.9 l-0.2,1l0.6,0.8l-0.6,2.6l-2.3,0.5v1.1l0.8,2.4l-1.1,6.1l-1.6,4l0.6,4.7l0.5,1.1l-0.8,2.4l-0.3,0.8l-0.3,2.7l3.6,6l2.9,6.5l1.5,4.8 l-0.8,4.7l-1,6l-2.4,5.2l-0.3,2.7l-3.3,3.1l4.4-0.2l21.4-2.3l7.3-1l0.1,1.7l6.9-1.2l10.3-1.5l3.9-0.5l0.1-0.6l0.2-1.5l2.1-3.7 l2-1.7l-0.2-5.1l1.6-1.6l1.1-0.3l0.2-3.6l1.5-3l1.1,0.6l0.2,0.6l0.8,0.2l1.9-1L871.9,277.2z M741.5,211.2l0.7-0.6l2.7-0.8l3.6-2.3 v-1l0.6-0.6l6-1l2.4-1.9l4.4-2.1l0.2-1.3l1.9-2.9l1.8-0.8l1.3-1.8l2.3-2.3l4.4-2.4l4.7-0.5l1.1,1.1l-0.3,1l-3.7,1l-1.5,3.1 l-2.3,0.8l-0.5,2.4l-2.4,3.2l-0.3,2.6l0.8,0.5l1-1.1l3.6-2.9l1.3,1.3h2.3l3.2,1l1.5,1.1l1.5,3.1l2.7,2.7l3.9-0.2l1.5-1l1.6,1.3 l1.6,0.5l1.3-0.8h1.1l1.6-1l4-3.6l3.4-1.1l6.6-0.3l4.5-1.9l2.6-1.3l1.5,0.2v5.7l0.5,0.3l2.9,0.8l1.9-0.5l6.1-1.6l1.1-1.1l1.5,0.5v7 l3.2,3.1l1.3,0.6l1.3,1l-1.3,0.3l-0.8-0.3l-3.7-0.5l-2.1,0.6l-2.3-0.2l-3.2,1.5h-1.8l-5.8-1.3l-5.2,0.2l-1.9,2.6l-7,0.6l-2.4,0.8 l-1.1,3.1l-1.3,1.1l-0.5-0.2l-1.5-1.6l-4.5,2.4h-0.6l-1.1-1.6l-0.8,0.2l-1.9,4.4l-1,4l-3.2,7l-1.2-1l-1.4-1l-1.9-10.3l-3.5-1.4 l-2.1-2.3l-12.1-2.7l-2.9-1l-8.2-2.2l-7.9-1.1L741.5,211.2z"
  },
  "MN": {
    "id": "MN",
    "name": "Minnesota",
    "capital": "St. Paul",
    "path": "M645.9,228.5l-0.5-8.5l-1.8-7.3l-1.8-13.5l-0.5-9.8l-1.8-3.4l-1.6-5v-10.3l0.7-3.9l-1.8-5.5l30.1,0 l0.3-8.2l0.6-0.2l2.3,0.5l1.9,0.8l0.8,5.5l1.5,6.1l1.6,1.6h4.8l0.3,1.5l6.3,0.3v2.1h4.8l0.3-1.3l1.1-1.1l2.3-0.6l1.3,1h2.9l3.9,2.6 l5.3,2.4l2.4,0.5l0.5-1l1.5-0.5l0.5,2.9l2.6,1.3l0.5-0.5l1.3,0.2v2.1l2.6,1h3.1l1.6-0.8l3.2-3.2l2.6-0.5l0.8,1.8l0.5,1.3h1l1-0.8 l8.9-0.3l1.8,3.1h0.6l0.7-1.1l4.4-0.4l-0.6,2.3l-3.9,1.8l-9.2,4.1l-4.8,2l-3.1,2.6l-2.4,3.6l-2.3,3.9l-1.8,0.8l-4.5,5l-1.3,0.2 l-3.8,2.9l-2.8,3.2l-0.2,3l0.2,7.8l-1.6,1.6L704,228l-1.8,5.7l2.5,3.6l0.5,2.5l-1.1,3l-0.2,3.7l0.5,7.1l3.4,4.1h3l2.5,2.3l3.2,1.4 l3.7,5l7.1,5l1.8,2.1l0.2,5.5l-20.6,0.7l-60.2,0.5l-0.3-35.7l-0.5-3l-4.1-3.4l-1.1-1.8v-1.6l2.1-1.6l1.4-1.4L645.9,228.5z"
  },
  "MS": {
    "id": "MS",
    "name": "Mississippi",
    "capital": "Jackson",
    "path": "M798.6,567l-0.3,1.3h-5.2l-1.5-0.8l-2.1-0.3l-6.8,1.9l-1.8-0.8l-2.6,4.2l-1.1,0.8l-1.1-2.5 l-1.1-3.9l-3.4-3.2l1.1-7.5l-0.7-0.9l-1.8,0.2l-8.2,0.7l-24.2,0.7l-0.5-1.6l0.7-8l3.4-6.2l5.3-9.1l-0.9-2.1h1.1l0.7-3.2l-2.3-1.8 l0.2-1.8l-2.1-4.6l-0.3-5.3l1.4-2.7l-0.4-4.3l-1.4-3l1.4-1.4l-1.4-2.1l0.5-1.8l0.9-6.2l3-2.7l-0.7-2.1l3.7-5.3l2.7-0.9v-2.5 l-0.7-1.4l2.7-5.3l2.7-1.1l0.1-3.4l8.7-0.1l24.1-1.9l4.6-0.2l0,6.4l0.2,16.7l-0.8,31l-0.2,14.1l2.7,18.8L798.6,567z"
  },
  "MO": {
    "id": "MO",
    "name": "Missouri",
    "capital": "Jefferson City",
    "path": "M729.8,349.5l-2.5-3.1l-1.1-2.3l-7.8,0.7l-9.8,0.5l-25.4,0.9l-13.5,0.2l-7.9,0.1l-2.3,0.1l1.3,2.5 l-0.2,2.3l2.5,3.9l3.1,4.1l3.1,2.7l2.3,0.2l1.4,0.9v3l-1.8,1.6l-0.5,2.3l2.1,3.4l2.5,3l2.5,1.8l1.4,11.7l-0.7,35.3l0.2,4.7l0.5,5.4 l23.4-0.1l23.2-0.7l20.8-0.8l11.7-0.2l2.2,3.4l-0.7,3.3l-3.1,2.4l-0.6,1.8l5.4,0.5l3.9-0.7l1.7-5.5l0.7-5.9l2.3-2l1.7-1.5l2.1-1 l0.1-2.9l0.6-1.7l-1-1.7l-2.7,0.1l-2.2-2.6l-1.4-4.2l0.8-2.5l-1.9-3.4l-1.8-4.6l-4.8-0.8l-7-5.6l-1.7-4.1l0.8-3.2l2.1-6.1l0.5-2.9 l-1.9-1l-6.9-0.8l-1-1.7l-0.1-4.2l-5.5-3.4l-7-7.8l-2.3-7.3l-0.2-4.2L729.8,349.5z"
  },
  "MT": {
    "id": "MT",
    "name": "Montana",
    "capital": "Helena",
    "path": "M530.7,222.3l0.6-11.2l2.3-24.8c0.5-5,1.1-8.5,1.4-15.4l0.9-14.6l-30.7-2.8L476,150l-29.3-4 l-32.3-5.3l-18.4-3.4l-32.7-6.9l-4.5,21.3l3.4,7.5l-1.4,4.6l1.8,4.6l3.2,1.4l4.6,10.8l2.7,3.2l0.5,1.1l3.4,1.1l0.5,2.1l-7.1,17.6 v2.5l2.5,3.2h0.9l4.8-3l0.7-1.1l1.6,0.7l-0.2,5.3l2.7,12.6l3,2.5l0.9,0.7l1.8,2.3l-0.5,3.4l0.7,3.4l1.1,0.9l2.3-2.3h2.7l3.2,1.6 l2.5-0.9h4.1l3.7,1.6l2.7-0.5l0.5-3l3-0.7l1.4,1.4l0.5,3.2l1.8,1.4l1.5-11.6l20.7,3l28.2,4l16.6,1.9l31.4,3.5l11,1.5l1.1-15.4 L530.7,222.3z"
  },
  "NE": {
    "id": "NE",
    "name": "Nebraska",
    "capital": "Lincoln",
    "path": "M658.2,347l1.4,2.7l0.1,2.1l2.4,3.7l2.7,3.2h-5l-43.5-0.9l-40.8-0.9l-21.2-1l1.1-21.3l-33.4-2.7 l4.3-44l15.5,1L562,290l17.8,1.1l23.8,1.1l10.7-0.5l2.1,2.3l4.8,3l1.1,0.9l4.3-1.4l3.9-0.5l2.7-0.2l1.8,1.4l5,1.6l3,1.6l0.5,1.6 l0.9,2.1h1.8l0.8,0l1,5.2l2.7,8l1.2,4.6l2.1,3.8l0.5,4.9l1.4,4.3l0.5,6.5"
  },
  "NV": {
    "id": "NV",
    "name": "Nevada",
    "capital": "Carson City",
    "path": "M314.7,277.6l21,4.5l9.7,1.9l9.3,1.8l6.6,1.6l-0.6,5.9l-3.5,17.3l-4.1,20l-1.9,9.7l-2.2,13.3 l-3.2,16.4l-3.5,15.7l-2,10.2l-2.5,16.8l-0.5,1.1l-1.1,2.5l-1.9-0.1l-1.1-2.7l-2.7-0.5l-1.4-1l-2,0.3l-0.9,0.7l-1.3,1.3l-0.4,7 l-0.5,1.7l-0.4,12.1l-1.3,1.7l-1.9-2.3l-14.5-22.7l-19.4-29L263.6,349l-12.4-18.6l1.6-6.6l7-25.9l7.9-31.3l33.6,8.1l13.7,3"
  },
  "NH": {
    "id": "NH",
    "name": "New Hampshire",
    "capital": "Concord",
    "path": "M1054.8,242.4l0.9-1.1l1.1-3.3l-2.5-0.9l-0.5-3.1l-3.9-1.1l-0.3-2.7l-7.3-23.4l-4.6-14.5l-0.9,0 l-0.6,1.6l-0.6-0.5l-1-1l-1.5,1.9l0,5l0.3,5.7l1.9,2.7v4l-3.7,5.1l-2.6,1.1v1.1l1.1,1.8v8.6l-0.8,9.2l-0.2,4.8l1,1.3l-0.2,4.5 l-0.5,1.8l1.5,0.9l16.4-4.7l2.3-0.6l1.5-2.6L1054.8,242.4z"
  },
  "NJ": {
    "id": "NJ",
    "name": "New Jersey",
    "capital": "Trenton",
    "path": "M1002.2,290.3l-2.1,2.4v3.1l-1.9,3.1l-0.2,1.6l1.3,1.3l-0.2,2.4l-2.3,1.1l0.8,2.7l0.2,1.1l2.7,0.3 l1,2.6l3.6,2.4l2.4,1.6v0.8l-3.2,3.1l-1.6,2.3l-1.5,2.7l-2.3,1.3l-1.2,0.7l-0.2,1.2l-0.6,2.6l1.1,2.2l3.2,2.9l4.8,2.3l4,0.6 l0.2,1.5l-0.8,1l0.3,2.7h0.8l2.1-2.4l0.8-4.8l2.7-4l3.1-6.5l1.1-5.5l-0.6-1.1l-0.2-9.4l-1.6-3.4l-1.1,0.8l-2.7,0.3l-0.5-0.5l1.1-1 l2.1-1.9l0.1-1.1l-0.4-3.4l0.5-2.7l-0.2-2.1l-2.6-1.1l-4.5-1l-3.9-1.1L1002.2,290.3z"
  },
  "NM": {
    "id": "NM",
    "name": "New Mexico",
    "capital": "Santa Fe",
    "path": "M456.7,531l-0.7-6.1l8.6,0.5l29.5,3.1l28.4,1.4l2-22.3l3.7-55.9l1.1-19.4l2,0.3l0-11.1l-32.2-2.4 l-36.9-4.4l-34.5-4.1l-4.2,30.8l-7,53.2l-3.8,26.9l-2,13.3l15.5,2l1.3-10l16.7,2.6L456.7,531z"
  },
  "NY": {
    "id": "NY",
    "name": "New York",
    "capital": "Albany",
    "path": "M1002.6,289.4l-1.1-1l-2.6-0.2l-2.3-1.9l-1.6-6.1l-3.5,0.1l-2.4-2.7l-19.4,4.4l-43,8.7l-7.5,1.2 l-0.7-6.5l1.4-1.1l1.3-1.1l1-1.6l1.8-1.1l1.9-1.8l0.5-1.6l2.1-2.7l1.1-1l-0.2-1l-1.3-3.1l-1.8-0.2l-1.9-6.1l2.9-1.8l4.4-1.5l4-1.3 l3.2-0.5l6.3-0.2l1.9,1.3l1.6,0.2l2.1-1.3l2.6-1.1l5.2-0.5l2.1-1.8l1.8-3.2l1.6-1.9h2.1l1.9-1.1l0.2-2.3l-1.5-2.1l-0.3-1.5l1.1-2.1 v-1.5h-1.8l-1.8-0.8l-0.8-1.1l-0.2-2.6l5.8-5.5l0.6-0.8l1.5-2.9l2.9-4.5l2.7-3.7l2.1-2.4l2.4-1.8l3.1-1.2l5.5-1.3l3.2,0.2l4.5-1.5 l7.6-2.1l0.5,5l2.4,6.5l0.8,5.2l-1,3.9l2.6,4.5l0.8,2.1l-0.8,2.9l2.9,1.3l0.6,0.3l3.1,11l-0.5,5.1l-0.5,10.8l0.8,5.5l0.8,3.6 l1.5,7.3v8.1l-1.1,2.3l1.8,2l0.8,1.7l-1.9,1.8l0.3,1.3l1.3-0.3l1.5-1.3l2.3-2.6l1.1-0.6l1.6,0.6l2.3,0.2l7.9-3.9l2.9-2.7l1.3-1.5 l4.2,1.6l-3.4,3.6l-3.9,2.9l-7.1,5.3l-2.6,1l-5.8,1.9l-4,1.1l-1.2-0.5l-0.2-3.7l0.5-2.7l-0.2-2.1l-2.8-1.7l-4.5-1l-3.9-1.1 L1002.6,289.4z"
  },
  "NC": {
    "id": "NC",
    "name": "North Carolina",
    "capital": "Raleigh",
    "path": "M1006.1,398.5l1.7,4.7l3.6,6.5l2.4,2.4l0.6,2.3l-2.4,0.2l0.8,0.6l-0.3,4.2l-2.6,1.3l-0.6,2.1 l-1.3,2.9l-3.7,1.6l-2.4-0.3l-1.5-0.2l-1.6-1.3l0.3,1.3v1h1.9l0.8,1.3l-1.9,6.3h4.2l0.6,1.6l2.3-2.3l1.3-0.5l-1.9,3.6l-3.1,4.8 h-1.3l-1.1-0.5l-2.7,0.6l-5.2,2.4l-6.5,5.3l-3.4,4.7l-1.9,6.5l-0.5,2.4l-4.7,0.5l-5.5,1.3l-9.9-8.2l-12.6-7.6l-2.9-0.8l-12.6,1.5 l-4.3,0.8l-1.6-3.2l-3-2.1l-16.5,0.5l-7.3,0.8l-9.1,4.5l-6.1,2.6l-1.6,0.3l-5.8,1l-7,0.8l-6.8,0.5l0.5-4.1l1.8-1.5l2.7-0.6l0.6-3.7 l4.2-2.7l3.9-1.5l4.2-3.6l4.4-2.1l0.6-3.1l3.9-3.9l0.6-0.2c0,0,0,1.1,0.8,1.1c0.8,0,1.9,0.3,1.9,0.3l2.3-3.6l2.1-0.6l2.3,0.3 l1.6-3.6l2.9-2.6l0.5-2.1v-4l4.5,0.7l7.1-1.3l15.8-1.9l17.1-2.6l19.9-4l19.7-4.2l11.4-2.8L1006.1,398.5z M1010,431.5l2.6-2.5 l3.2-2.6l1.5-0.6l0.2-2l-0.6-6.1l-1.5-2.3l-0.6-1.9l0.7-0.2l2.7,5.5l0.4,4.4l-0.2,3.4l-3.4,1.5l-2.8,2.4l-1.1,1.2L1010,431.5z"
  },
  "ND": {
    "id": "ND",
    "name": "North Dakota",
    "capital": "Bismarck",
    "path": "M645.3,227.7l-0.4-7.5l-2-7.3l-1.8-13.6l-0.5-9.8l-2-3.1l-1.6-5.4v-10.3l0.7-3.9l-2.1-5.5 l-28.4-0.6l-18.6-0.6l-26.5-1.3l-24.9-1.9l-1.3,14.2l-1.4,15.1l-2.3,24.9l-0.5,11l56.8,3.8L645.3,227.7z"
  },
  "OH": {
    "id": "OH",
    "name": "Ohio",
    "capital": "Columbus",
    "path": "M905.4,295l-6.1,4.1l-3.9,2.3l-3.4,3.7l-4,3.9l-3.2,0.8l-2.9,0.5l-5.5,2.6l-2.1,0.2l-3.4-3.1 l-5.2,0.6l-2.6-1.5l-2.4-1.4l-4.9,0.7l-10.2,1.6l-7.8,1.2l1.3,14.6l1.8,13.7l2.6,23.4l0.6,4.8l4.1-0.1l2.4-0.8l3.4,1.5l2.1,4.4 l5.1,0l1.9,2.1l1.8-0.1l2.5-1.3l2.5,0.4l2,1.5l1.7-2.1l2.3-1.3l2.1-0.7l0.6,2.7l1.8,1l3.5,2.3l2.2-0.1l1.1-1.1l-0.1-1.4l1.6-1.5 l0.2-5l1-3.9l1.5-1.4l1.5,0.9l0.8,1.2l1.2-0.2l-0.4-2.4l-0.6-0.6v-2.4l1-1.3l2.3-3.4l1.3-1.5l2.1,0.5l2.3-1.6l3.1-3.4l2.3-3.9 l0.2-5.4l0.5-5v-4.7l-1.1-3.1l1-1.5l0.9-1l-1.4-9.8L905.4,295z"
  },
  "OK": {
    "id": "OK",
    "name": "Oklahoma",
    "capital": "Oklahoma City",
    "path": "M549.3,422.6l-10.7-0.5l-6.4-0.5l0.3,0.2l-0.7,10.4l22,1.4l32.1,1.3l-2.3,24.4l-0.5,17.8l0.2,1.6 l4.3,3.7l2.1,1.1l0.7-0.2l0.7-2.1l1.4,1.8h2.1v-1.4l2.7,1.4l-0.5,3.9l4.1,0.2l2.5,1.1l4.1,0.7l2.5,1.8l2.3-2.1l3.4,0.7l2.5,3.4h0.9 v2.3l2.3,0.7l2.3-2.3l1.8,0.7h2.5l0.9,2.5l4.8,1.8l1.4-0.7l1.8-4.1h1.1l1.1,2.1l4.1,0.7l3.7,1.4l3,0.9l1.8-0.9l0.7-2.5h4.3l2.1,0.9 l2.7-2.1h1.1l0.7,1.6h4.1l1.6-2.1l1.8,0.5l2.1,2.5l3.2,1.8l3.2,0.9l1.9,1.1l-0.4-37.2l-1.4-11l-0.2-8.9l-1.4-6.5l-0.8-7.2l-0.1-3.8 l-12.1,0.3l-46.4-0.5l-45-2.1L549.3,422.6z"
  },
  "OR": {
    "id": "OR",
    "name": "Oregon",
    "capital": "Salem",
    "path": "M314.3,276.7l4.3-17.9l4.7-17.9l1.1-4.2l2.4-5.6l-0.6-1.2l-2.5,0l-1.3-1.7l0.5-1.5l0.5-3.2l4.5-5.5 l1.8-1.1l1.1-1.1l1.5-3.6l4-5.7l3.6-3.9l0.2-3.5l-3.3-2.5l-1.2-4.5l-13.2-3.7l-15.1-3.5l-15.4,0.1l-0.5-1.4l-5.5,2.1l-4.5-0.6 l-2.4-1.6l-1.3,0.7L273,184l-1.7-1.4l-5.3-2.1l-0.8,0.1l-4.3-1.5l-1.9,1.8l-6.2-0.3l-5.9-4.1l0.7-0.8l0.2-7.8l-2.3-3.9l-4.1-0.6 l-0.7-2.5l-2.4-0.5l-5.8,2.1l-2.3,6.5l-3.2,10l-3.2,6.5l-5,14.1l-6.5,13.6l-8.1,12.6l-1.9,2.9l-0.8,8.6l-1.3,6l2.7,3.5l6.7,2.3 l11.6,3.3l7.9,2.5l12.4,3.6l13.3,3.6l13.2,3.6"
  },
  "PA": {
    "id": "PA",
    "name": "Pennsylvania",
    "capital": "Harrisburg",
    "path": "M996.2,326.5l1.1-0.6l2.3-0.6l1.5-2.7l1.6-2.3l3.2-3.1v-0.8l-2.4-1.6l-3.6-2.4l-1-2.6l-2.7-0.3 l-0.2-1.1l-0.8-2.7l2.3-1.1l0.2-2.4l-1.3-1.3l0.2-1.6l1.9-3.1v-3.1l2.3-2.4l0.2-1.1l-2.6-0.2l-2.3-1.9l-2.4-5.3l-3-0.9l-2.3-2.1 l-18.6,4l-43,8.7l-8.9,1.5l-0.5-7.1l-5.5,5.6l-1.3,0.5l-4.2,3l2.9,19.1l2.5,9.7l3.6,19.3l3.3-0.6l11.9-1.5l37.9-7.7l14.9-2.8 l8.3-1.6l0.3-0.2l2.1-1.6L996.2,326.5z"
  },
  "RI": {
    "id": "RI",
    "name": "Rhode Island",
    "capital": "Providence",
    "path": "M1048.1,279.8l-0.5-4.2l-0.8-4.4l-1.7-5.9l5.7-1.5l1.6,1.1l3.4,4.4l2.9,4.4l-2.9,1.5l-1.3-0.2 l-1.1,1.8l-2.4,1.9L1048.1,279.8z"
  },
  "SC": {
    "id": "SC",
    "name": "South Carolina",
    "capital": "Columbia",
    "path": "M935.2,512.9l-1.8,1l-2.6-1.3l-0.6-2.1l-1.3-3.6l-2.3-2.1l-2.6-0.6l-1.6-4.8l-2.7-6l-4.2-1.9 l-2.1-1.9l-1.3-2.6L910,485l-2.3-1.3l-2.3-2.9l-3.1-2.3l-4.5-1.8l-0.5-1.5l-2.4-2.9l-0.5-1.5l-3.4-5.2l-3.4,0.2l-4-2.4l-1.3-1.3 l-0.3-1.8l0.8-1.9l2.3-1l-0.3-2.1l6.1-2.6l9.1-4.5l7.3-0.8l16.5-0.5l2.3,1.9l1.6,3.2l4.4-0.5l12.6-1.5l2.9,0.8l12.6,7.6l10.1,8.1 l-5.4,5.5l-2.6,6.1l-0.5,6.3l-1.6,0.8l-1.1,2.7l-2.4,0.6l-2.1,3.6l-2.7,2.7l-2.3,3.4l-1.6,0.8l-3.6,3.4l-2.9,0.2l1,3.2l-5,5.5 L935.2,512.9z"
  },
  "SD": {
    "id": "SD",
    "name": "South Dakota",
    "capital": "Pierre",
    "path": "M646.8,303.2l-1-1.1l-1.5-3.6l1.8-3.7l1.1-5.6l-2.6-2.1l-0.3-2.7l0.6-3l2.2-0.8l0.3-5.7l-0.1-30.1 l-0.6-3l-4.1-3.6l-1-2v-1.9l1.9-1.3l1.5-1.9l0.2-2.7l-57.4-1.6l-56.2-3.9l-0.8,5.3l-1.6,15.9l-1.3,17.9l-1.6,24.6l16,1l19.6,1.1 l18,1.3l23.8,1.3l10.7-0.8l2.9,2.3l4.3,3l1,0.8l3.5-0.9l4-0.3l2.7-0.1l3.1,1.2l4.5,1.4l3.1,1.8l0.6,1.9l0.9,1.9l0.7-0.5 L646.8,303.2z"
  },
  "TN": {
    "id": "TN",
    "name": "Tennessee",
    "capital": "Nashville",
    "path": "M871.1,420.6l-51.9,5l-15.8,1.8l-4.6,0.5l-3.9,0v3.9l-8.4,0.5l-7,0.6l-11.1,0.1l-0.3,5.8l-2.1,6.3 l-1,3l-1.3,4.4l-0.3,2.6l-4,2.3l1.5,3.6l-1,4.4l-1,0.8l7.3-0.2l24.1-1.9l5.3-0.2l8.1-0.5l27.8-2.6l10.2-0.8l8.4-1l8.4-1.1l4.8-0.8 l-0.1-4.5l1.8-1.5l2.7-0.6l0.6-3.7l4.2-2.7l3.9-1.5l4.2-3.6l4.4-2.1l0.9-3.5l4.3-3.9l0.6-0.2c0,0,0,1.1,0.8,1.1s1.9,0.3,1.9,0.3 l2.3-3.6l2.1-0.6l2.3,0.3l1.6-3.6l2.1-2.2l0.6-1l0.2-3.9l-1.5-0.3l-2.4,1.9l-7.9,0.2l-12,1.9L871.1,420.6z"
  },
  "TX": {
    "id": "TX",
    "name": "Texas",
    "capital": "Austin",
    "path": "M531.1,433.4l22.7,1.1l31.1,1.1l-2.3,23.5l-0.3,18.2l0.1,2.1l4.3,3.8l1.7,0.8l1.8,0.3l0.7-1.3 l0.9,0.9l1.7,0.5l1.6-0.7l1.1,0.4l-0.3,3.4l4.3,1l2.7,0.8l4,0.5l2.2,1.8l3.2-1.6l2.8,0.4l2,2.8l1.1,0.3l-0.2,2l3.1,1.2l2.8-1.8 l1.5,0.4l2.4,0.2l0.4,1.9l4.6,2l2.7-0.2l2-4.1h0.3l1.1,1.9l4.4,1l3.3,1.2l3.3,0.8l2.1-0.8l0.8-2.5h3.7l1.9,0.8l3.1-1.6h0.7l0.4,1.1 h4.3l2.4-1.3l1.7,0.3l1.4,1.9l2.9,1.7l3.5,1.1l2.7,1.4l2.4,1.6l3.3-0.9l1.9,1l0.5,10.1l0.3,9.7l0.7,9.5l0.5,4l2.7,4.6l1.1,4.1 l3.9,6.3l0.5,2.9l0.5,1l-0.7,7.5l-2.7,4.4l1,2.9l-0.4,2.5l-0.8,7.3l-1.4,2.7l0.6,4.4l-5.7,1.6l-9.9,4.5l-1,1.9l-2.6,1.9l-2.1,1.5 l-1.3,0.8l-5.7,5.3l-2.7,2.1l-5.3,3.2l-5.7,2.4l-6.3,3.4l-1.8,1.5l-5.8,3.6l-3.4,0.6l-3.9,5.5l-4,0.3l-1,1.9l2.3,1.9l-1.5,5.5 l-1.3,4.5l-1.1,3.9l-0.8,4.5l0.8,2.4l1.8,7l1,6.1l1.8,2.7l-1,1.5l-3.1,1.9l-5.7-3.9l-5.5-1.1l-1.3,0.5l-3.2-0.6l-4.2-3.1l-5.2-1.1 l-7.6-3.4l-2.1-3.9l-1.3-6.5l-3.2-1.9l-0.6-2.3l0.6-0.6l0.3-3.4l-1.3-0.6l-0.6-1l1.3-4.4l-1.6-2.3l-3.2-1.3l-3.4-4.4l-3.6-6.6 l-4.2-2.6l0.2-1.9l-5.3-12.3l-0.8-4.2l-1.8-1.9l-0.2-1.5l-6-5.3l-2.6-3.1v-1.1l-2.6-2.1l-6.8-1.1l-7.4-0.6l-3.1-2.3l-4.5,1.8 l-3.6,1.5l-2.3,3.2l-1,3.7l-4.4,6.1l-2.4,2.4l-2.6-1l-1.8-1.1l-1.9-0.6l-3.9-2.3v-0.6l-1.8-1.9l-5.2-2.1l-7.4-7.8l-2.3-4.7v-8.1 l-3.2-6.5l-0.5-2.7l-1.6-1l-1.1-2.1l-5-2.1l-1.3-1.6l-7.1-7.9l-1.3-3.2l-4.7-2.3l-1.5-4.4l-2.6-2.9l-1.9-0.5l-0.6-4.7l8,0.7l29,2.7 l29,1.6l2.3-23.8l3.9-55.6l1.6-18.7l1.4,0 M631.2,667.3l-0.6-7.1l-2.7-7.2l-0.6-7l1.5-8.2l3.3-6.9l3.5-5.4l3.2-3.6l0.6,0.2 l-4.8,6.6l-4.4,6.5l-2,6.6l-0.3,5.2l0.9,6.1l2.6,7.2l0.5,5.2l0.2,1.5L631.2,667.3z"
  },
  "UT": {
    "id": "UT",
    "name": "Utah",
    "capital": "Salt Lake City",
    "path": "M427,409.3l-24.6-3.5l-26.6-4.9l-33.8-6l1.6-9.2l3.2-15.2L350,354l2.2-13.6l1.9-8.9l3.8-20.5 l3.5-17.5l1.1-5.6l12.7,2.3l12,2.1l10.3,1.8l8.3,1.4l3.7,0.5l-1.5,10.6l-2.3,13.2l7.8,0.9l16.4,1.8l8.2,0.9l-2.1,22l-3.2,22.6 l-3.8,27.8l-1.7,11.1L427,409.3z"
  },
  "VT": {
    "id": "VT",
    "name": "Vermont",
    "capital": "Montpelier",
    "path": "M1018.3,253.7l-0.8-5.7l-2.4-10l-0.6-0.3l-2.9-1.3l0.8-2.9l-0.8-2.1l-2.7-4.6l1-3.9l-0.8-5.2 l-2.4-6.5l-0.8-4.9l26.2-6.7l0.3,5.8l1.9,2.7v4l-3.7,4l-2.6,1.1v1.1l1.1,1.8v8.6l-0.8,9.2l-0.2,4.8l1,1.3l-0.2,4.5l-0.5,1.8 l0.7,1.6l-7,1.4L1018.3,253.7z"
  },
  "VA": {
    "id": "VA",
    "name": "Virginia",
    "capital": "Richmond",
    "path": "M1002.9,369.2l-0.1-1.9l6.5-2.5l-0.8,3.2l-2.9,3.8l-0.4,4.6l0.5,3.4l-1.8,5l-2.2,1.9l-1.5-4.6 l0.4-5.4l1.6-4.2L1002.9,369.2z M1005.2,397.5L947,410.1l-37.4,5.3l-6.7-0.4l-2.6,1.9l-7.3,0.2l-8.4,1l-8.9,1l8.5-4.9l0-2.1 l1.5-2.1l10.6-11.5l3.9,4.5l3.8,1l2.5-1.1l2.2-1.3l2.5,1.3l3.9-1.4l1.9-4.6l2.6,0.5l2.9-2.1l1.8,0.5l2.8-3.7l0.3-2.1l-1-1.3l1-1.9 l5.3-12.3l0.6-5.7l1.2-0.5l2.2,2.4l3.9-0.3l1.9-7.6l2.8-0.6l1-2.7l2.6-2.3l1.3-2.3l1.5-3.4l0.1-5.1l9.8,3.8 c0.7,0.3,0.7-4.8,0.7-4.8l4.1,1.4l-0.5,2.6l8.2,2.9l1.3,1.8l-0.9,3.7l-1.3,1.3l-0.5,1.7l0.5,2.4l2,1.3l3.9,1.4l2.9,1l4.9,0.9 l2.2,2.1l3.2,0.4l0.9,1.2l-0.4,4.7l1.4,1.1l-0.5,1.9l1.2,0.8l-0.2,1.4l-2.7-0.1l0.1,1.6l2.3,1.5l0.1,1.4l1.8,1.8l0.5,2.5l-2.6,1.4 l1.6,1.5l5.8-1.7L1005.2,397.5z"
  },
  "WA": {
    "id": "WA",
    "name": "Washington",
    "capital": "Olympia",
    "path": "M267.6,106.4l4.4,1.5l9.7,2.7l8.6,1.9l20,5.7l23,5.7l15.2,3.4l-1,3.9l-4.1,13.8l-4.5,20.8 l-3.2,16.1l-0.4,9.4l-13.2-3.9l-15.6-3.4l-13.7,0.6l-1.6-1.5l-5.3,1.9l-4-0.3l-2.7-1.8l-1.6,0.5l-4.2-0.2l-1.9-1.4l-4.8-1.7 l-1.4-0.2l-5-1.3l-1.8,1.5l-5.7-0.3l-4.8-3.8l0.2-0.8l0.1-7.9l-2.1-3.9l-4.1-0.7l-0.4-2.4l-2.5-0.6l-2.9-0.5l-1.8,1l-2.3-2.9 l0.3-2.9l2.7-0.3l1.6-4l-2.6-1.1l0.2-3.7l4.4-0.6l-2.7-2.7l-1.5-7.1l0.6-2.9v-7.9l-1.8-3.2l2.3-9.4l2.1,0.5l2.4,2.9l2.7,2.6 l3.2,1.9l4.5,2.1l3.1,0.6l2.9,1.5l3.4,1l2.3-0.2v-2.4l1.3-1.1l2.1-1.3l0.3,1.1l0.3,1.8l-2.3,0.5l-0.3,2.1l1.8,1.5l1.1,2.4l0.6,1.9 l1.5-0.2l0.2-1.3l-1-1.3l-0.5-3.2l0.8-1.8l-0.6-1.5V119l1.8-3.6l-1.1-2.6l-2.4-4.8l0.3-0.8L267.6,106.4z M258.1,112.3l2-0.2 l0.5,1.4l1.5-1.6h2.3l0.8,1.5l-1.5,1.7l0.6,0.8l-0.7,2l-1.4,0.4c0,0-0.9,0.1-0.9-0.2s1.5-2.6,1.5-2.6l-1.7-0.6l-0.3,1.5l-0.7,0.6 l-1.5-2.3L258.1,112.3z"
  },
  "WV": {
    "id": "WV",
    "name": "West Virginia",
    "capital": "Charleston",
    "path": "M930.6,342l1.1,4.9l1.1,6.9l3.6-2.7l2.3-3.1l2.5-0.6l1.5-1.5l1.8-2.6l1.2,0.6l2.9-0.3l2.6-2.1 l2-1.5l1.8-0.5l1.3,1l2.2,1.1l1.9,1.8l1.4,1.3l-0.1,4.7l-5.7-3.1l-4.5-1.8l-0.2,5.3l-0.5,2.1l-1.6,2.7l-0.6,1.6l-3.1,2.4l-0.5,2.3 l-3.4,0.3l-0.3,3.1l-1.1,5.5h-2.6l-1.3-0.8l-1.6-2.7l-1.8,0.2l-0.3,4.4l-2.1,6.6l-5,10.8l0.8,1.3l-0.2,2.7l-2.1,1.9l-1.5-0.3 l-3.2,2.4l-2.6-1l-1.8,4.7c0,0-3.7,0.8-4.4,1c-0.6,0.2-2.4-1.3-2.4-1.3l-2.4,2.3l-2.6,0.6l-2.9-0.8l-1.3-1.3l-2.2-3l-3.1-2 l-2.6-2.7l-2.9-3.7l-0.6-2.3l-2.6-1.5l-0.8-1.6l-0.2-5.3l2.2-0.1l1.9-0.8l0.2-2.7l1.6-1.5l0.2-5l1-3.9l1.3-0.6l1.3,1.1l0.5,1.8 l1.8-1l0.5-1.6l-1.1-1.8v-2.4l1-1.3l2.3-3.4l1.3-1.5l2.1,0.5l2.3-1.6l3.1-3.4l2.3-3.9l0.3-5.7l0.5-5v-4.7l-1.1-3.1l1-1.5l1.3-1.3 l3.5,19.8l4.6-0.8L930.6,342z"
  },
  "WI": {
    "id": "WI",
    "name": "Wisconsin",
    "capital": "Madison",
    "path": "M786.9,297.2l0.4-3l-1.6-4.5l-0.6-6.1l-1.1-2.4l1-3.1l0.8-2.9l1.5-2.6l-0.6-3.4l-0.6-3.6l0.5-1.8 l1.9-2.4l0.2-2.7l-0.8-1.3l0.6-2.6l0.5-3.2l2.7-5.7l2.9-6.8l0.2-2.3l-0.3-1l-0.8,0.5l-4.2,6.3l-2.7,4l-1.9,1.8l-0.8,2.3l-1.5,0.8 l-1.1,1.9l-1.5-0.3l-0.2-1.8l1.3-2.4l2.1-4.7l1.8-1.6l1.1-2.3l-1.6-0.9l-1.4-1.4l-1.6-10.3l-3.7-1.1l-1.4-2.3l-12.6-2.7l-2.5-1.1 l-8.2-2.3l-8.2-1.1l-4.2-5.4l-0.5,1.3l-1.1-0.2l-0.6-1.1l-2.7-0.8l-1.1,0.2l-1.8,1l-1-0.6l0.6-1.9l1.9-3.1l1.1-1.1l-1.9-1.5 l-2.1,0.8l-2.9,1.9l-7.4,3.2l-2.9,0.6l-2.9-0.5l-1-0.9l-2.1,2.8l-0.2,2.7v8.5l-1.1,1.6l-5.3,3.9l-2.3,5.9l0.5,0.2l2.5,2.1l0.7,3.2 l-1.8,3.2v3.9l0.5,6.6l3,3h3.4l1.8,3.2l3.4,0.5l3.9,5.7l7.1,4.1l2.1,2.7l0.9,7.4l0.7,3.3l2.3,1.6l0.2,1.4l-2.1,3.4l0.2,3.2l2.5,3.9 l2.5,1.1l3,0.5l1.3,1.4l9.2,0l26.1-1.5L786.9,297.2z"
  },
  "WY": {
    "id": "WY",
    "name": "Wyoming",
    "capital": "Cheyenne",
    "path": "M528.3,243.8l-10.5-0.8l-32.1-3.3l-16.2-2.1l-28.3-4.1l-19.9-3l-1.4,11.2l-3.8,24.3l-5.3,30.4 l-1.5,10.5l-1.7,11.9l6.5,0.9l25.9,2.5l20.6,2.3l36.8,4.1l23.8,2.9l4.5-44.2l1.4-25.4L528.3,243.8z"
  }
};

// Make it available on window for browser-level access
if (typeof window !== 'undefined') {
    window.US_STATES_DATA = US_STATES_DATA;
}

if (typeof module !== 'undefined' && module.exports) {
    module.exports = { US_STATES_DATA };
}

;
/**
 * CosmicMatch USA - Core Numerology Engine & Application State
 */

// --- 1. NUMEROLOGY ALPHABET MAPPINGS ---
const PYTHAGOREAN_MAP = {
    'A': 1, 'B': 2, 'C': 3, 'D': 4, 'E': 5, 'F': 6, 'G': 7, 'H': 8, 'I': 9,
    'J': 1, 'K': 2, 'L': 3, 'M': 4, 'N': 5, 'O': 6, 'P': 7, 'Q': 8, 'R': 9,
    'S': 1, 'T': 2, 'U': 3, 'V': 4, 'W': 5, 'X': 6, 'Y': 7, 'Z': 8
};

const CHALDEAN_MAP = {
    'A': 1, 'I': 1, 'J': 1, 'Q': 1, 'Y': 1,
    'B': 2, 'K': 2, 'R': 2,
    'C': 3, 'G': 3, 'L': 3, 'S': 3,
    'D': 4, 'M': 4, 'T': 4,
    'E': 5, 'H': 5, 'N': 5, 'X': 5,
    'U': 6, 'V': 6, 'W': 6,
    'O': 7, 'Z': 7,
    'F': 8, 'P': 8
};

// Vowels for Soul Urge calculation
const VOWELS = ['A', 'E', 'I', 'O', 'U'];

// --- 2. CORE HELPER FUNCTIONS ---

/**
 * Reduce a number to a single digit (1-9), with optional support for Master Numbers (11, 22, 33).
 */
function reduceNumber(num, keepMaster = true) {
    if (num === 0) return 0;
    
    while (num > 9) {
        if (keepMaster && (num === 11 || num === 22 || num === 33)) {
            return num;
        }
        num = num.toString().split('').reduce((sum, d) => sum + parseInt(d, 10), 0);
    }
    return num;
}

/**
 * Clean and normalize a string to uppercase letters only
 */
function cleanName(name) {
    return name.toUpperCase().replace(/[^A-Z]/g, '');
}

/**
 * Calculate the single/master digit value of a string using a specific mapping
 */
function sumNameLetters(name, map, onlyVowels = false, onlyConsonants = false) {
    const cleaned = cleanName(name);
    let sum = 0;
    
    for (let char of cleaned) {
        const isVowel = VOWELS.includes(char);
        if (onlyVowels && !isVowel) continue;
        if (onlyConsonants && isVowel) continue;
        
        sum += map[char] || 0;
    }
    
    return sum;
}

/**
 * Parse birthdate string (YYYY-MM-DD) into day, month, year values
 */
function parseBirthdate(dateStr) {
    if (!dateStr) return { day: 1, month: 1, year: 2000 };
    const parts = dateStr.split('-');
    return {
        year: parseInt(parts[0], 10),
        month: parseInt(parts[1], 10),
        day: parseInt(parts[2], 10)
    };
}

// --- 3. THE NUMEROLOGY ENGINE ---

/**
 * Calculates core Pythagorean and Chaldean numbers for an individual
 */
function calculateIndividualNumerology(name, birthdateStr) {
    const cleaned = cleanName(name);
    const { day, month, year } = parseBirthdate(birthdateStr);
    
    // --- birthdate calculations ---
    // Life Path: sum day + month + year reduced
    const dayReduced = reduceNumber(day, false);
    const monthReduced = reduceNumber(month, false);
    const yearReduced = reduceNumber(year, false);
    const lifePathSum = dayReduced + monthReduced + yearReduced;
    const lifePath = reduceNumber(lifePathSum, true); // Keep master numbers
    
    const birthDay = reduceNumber(day, true); // Birth day number
    
    // --- Pythagorean calculations ---
    const pythDestinyRaw = sumNameLetters(cleaned, PYTHAGOREAN_MAP);
    const pythDestiny = reduceNumber(pythDestinyRaw, true);
    
    const pythSoulUrgeRaw = sumNameLetters(cleaned, PYTHAGOREAN_MAP, true, false);
    const pythSoulUrge = reduceNumber(pythSoulUrgeRaw, true);
    
    const pythPersonalityRaw = sumNameLetters(cleaned, PYTHAGOREAN_MAP, false, true);
    const pythPersonality = reduceNumber(pythPersonalityRaw, true);
    
    // --- Chaldean calculations ---
    const chalDestinyRaw = sumNameLetters(cleaned, CHALDEAN_MAP);
    const chalDestiny = reduceNumber(chalDestinyRaw, true);
    
    const chalSoulUrgeRaw = sumNameLetters(cleaned, CHALDEAN_MAP, true, false);
    const chalSoulUrge = reduceNumber(chalSoulUrgeRaw, true);
    
    const chalPersonalityRaw = sumNameLetters(cleaned, CHALDEAN_MAP, false, true);
    const chalPersonality = reduceNumber(chalPersonalityRaw, true);
    
    return {
        lifePath,
        birthDay,
        pythagorean: {
            destiny: pythDestiny,
            soulUrge: pythSoulUrge,
            personality: pythPersonality
        },
        chaldean: {
            destiny: chalDestiny,
            soulUrge: chalSoulUrge,
            personality: chalPersonality
        }
    };
}

// --- 4. COMPATIBILITY ALIGNMENT DATA ---

// Standard numerology compatibility matrix
// Keys represent digits 1-9 (Master numbers are reduced to their single-digit values 2, 4, 6 for compatibility mapping)
const COMPATIBILITY_RELATIONS = {
    1: { compatible: [1, 3, 5, 7, 9], challenging: [4, 6, 8], neutral: [2] },
    2: { compatible: [2, 4, 6, 8], challenging: [5, 7, 9], neutral: [1, 3] },
    3: { compatible: [1, 3, 5, 6, 9], challenging: [4, 7, 8], neutral: [2] },
    4: { compatible: [2, 4, 6, 7, 8], challenging: [1, 3, 5, 9], neutral: [] },
    5: { compatible: [1, 3, 5, 7, 9], challenging: [2, 4, 6, 8], neutral: [] },
    6: { compatible: [2, 3, 6, 9], challenging: [1, 5, 7], neutral: [4, 8] },
    7: { compatible: [1, 4, 5, 7, 8], challenging: [2, 6, 9], neutral: [3] },
    8: { compatible: [2, 4, 7, 8], challenging: [1, 3, 5, 9], neutral: [6] },
    9: { compatible: [1, 3, 6, 9], challenging: [2, 4, 7, 8], neutral: [5] }
};

/**
 * Calculates a numerical score (40-100) between two numbers
 */
function getNumbersCompatibility(num1, num2) {
    // Reduce master numbers for relation lookup
    const r1 = num1 > 9 ? reduceNumber(num1, false) : num1;
    const r2 = num2 > 9 ? reduceNumber(num2, false) : num2;
    
    if (r1 === r2) return 98; // Identical vibrations are extremely compatible
    
    const relations = COMPATIBILITY_RELATIONS[r1];
    if (!relations) return 75; // Neutral default fallback
    
    if (relations.compatible.includes(r2)) {
        return 95; // Highly compatible
    } else if (relations.challenging.includes(r2)) {
        return 50; // Challenging
    } else {
        return 75; // Neutral
    }
}

// --- 5. STATE NUMEROLOGICAL VALUES ---
// In a real system, state names themselves carry numerological values. We pre-compute them for all 50 states!
const STATE_NUMEROLOGY = {};

function precomputeStateNumerology() {
    if (typeof US_STATES_DATA === 'undefined') return;
    
    for (let id in US_STATES_DATA) {
        const name = cleanName(US_STATES_DATA[id].name);
        
        const pythRaw = sumNameLetters(name, PYTHAGOREAN_MAP);
        const pythDestiny = reduceNumber(pythRaw, true);
        const pythVowels = reduceNumber(sumNameLetters(name, PYTHAGOREAN_MAP, true, false), true);
        
        const chalRaw = sumNameLetters(name, CHALDEAN_MAP);
        const chalDestiny = reduceNumber(chalRaw, true);
        const chalVowels = reduceNumber(sumNameLetters(name, CHALDEAN_MAP, true, false), true);
        
        STATE_NUMEROLOGY[id] = {
            pythagorean: {
                destiny: pythDestiny,
                vowels: pythVowels
            },
            chaldean: {
                destiny: chalDestiny,
                vowels: chalVowels
            }
        };
    }
}

// --- 6. COMBINED COMPATIBILITY ENGINE ---

/**
 * Calculates state-person overall compatibility percentage (0-100)
 */
function calculateStateCompatibility(personNumerology, stateId) {
    const stateNum = STATE_NUMEROLOGY[stateId];
    if (!stateNum) return 70; // Default
    
    // We weight multiple factors:
    // 1. Pythagorean Destiny vs State Pythagorean Destiny (25%)
    const score1 = getNumbersCompatibility(personNumerology.pythagorean.destiny, stateNum.pythagorean.destiny);
    
    // 2. Chaldean Destiny vs State Chaldean Destiny (25%)
    const score2 = getNumbersCompatibility(personNumerology.chaldean.destiny, stateNum.chaldean.destiny);
    
    // 3. Life Path vs Average State Name Vibrations (25%)
    const stateAvgVibe = reduceNumber(stateNum.pythagorean.destiny + stateNum.chaldean.destiny, false);
    const score3 = getNumbersCompatibility(personNumerology.lifePath, stateAvgVibe);
    
    // 4. Soul Urge vs State Vowels Vibrations (15%)
    const score4 = getNumbersCompatibility(personNumerology.pythagorean.soulUrge, stateNum.pythagorean.vowels);
    
    // 5. Birth Day vs State Average Name Vibrations (10%)
    const score5 = getNumbersCompatibility(personNumerology.birthDay, stateAvgVibe);
    
    // Weighted sum
    const totalScore = (score1 * 0.25) + (score2 * 0.25) + (score3 * 0.25) + (score4 * 0.15) + (score5 * 0.10);
    
    // Round to whole number and ensure it fits standard percentages gracefully (e.g. 30% to 99%)
    return Math.min(99, Math.max(30, Math.round(totalScore)));
}

/**
 * Calculate compatibility breakdowns for all 8 life phases based on state and individual numerology
 */
function calculateLifePhasesBreakdown(personNumerology, stateId, baseCompatibility) {
    const stateNum = STATE_NUMEROLOGY[stateId];
    const stateAvg = reduceNumber(stateNum.pythagorean.destiny + stateNum.chaldean.destiny, false);
    const lp = personNumerology.lifePath;
    const dest = personNumerology.pythagorean.destiny;
    
    // Custom modifiers based on astrological numbers that rule specific domains
    
    // 1. Career: ruled by Action, Will, Ambition (1, 8, 9)
    let careerMod = 0;
    if ([1, 8, 9].includes(reduceNumber(lp, false)) || [1, 8, 9].includes(stateAvg)) careerMod += 8;
    if (dest === 8 || lp === 1) careerMod += 5;
    const career = Math.min(99, Math.max(35, Math.round(baseCompatibility * 0.95 + careerMod)));
    
    // 2. Education: ruled by Knowledge, Logic, Analysis (5, 7, 3)
    let eduMod = 0;
    if ([3, 5, 7].includes(reduceNumber(lp, false)) || [3, 5, 7].includes(stateAvg)) eduMod += 10;
    if (dest === 7 || lp === 5) eduMod += 4;
    const education = Math.min(99, Math.max(35, Math.round(baseCompatibility * 0.93 + eduMod)));
    
    // 3. Finance: ruled by Abundance, Organization (8, 4, 2)
    let finMod = 0;
    if ([8, 4, 2].includes(reduceNumber(lp, false)) || [8, 4, 2].includes(stateAvg)) finMod += 8;
    if (dest === 8 || lp === 22) finMod += 8; // Master Number 22 is builder of material structures
    const finance = Math.min(99, Math.max(30, Math.round(baseCompatibility * 0.92 + finMod)));
    
    // 4. Happiness: ruled by Joy, Relationships (3, 6, 2)
    let hapMod = 0;
    if ([3, 6, 2].includes(reduceNumber(lp, false)) || [3, 6, 2].includes(stateAvg)) hapMod += 12;
    if (dest === 3 || lp === 6 || lp === 11) hapMod += 6; // Master Number 11 rules high spiritual joy
    const happiness = Math.min(99, Math.max(40, Math.round(baseCompatibility * 0.90 + hapMod)));
    
    // 5. Growth: ruled by Travel, Adaptability (5, 9, 3)
    let groMod = 0;
    if ([5, 9, 3].includes(reduceNumber(lp, false)) || [5, 9, 3].includes(stateAvg)) groMod += 9;
    if (lp === 5 || lp === 9) groMod += 5;
    const growth = Math.min(99, Math.max(35, Math.round(baseCompatibility * 0.94 + groMod)));
    
    // 6. Success: ruled by Accomplishment, Leadership (8, 1, 9)
    let sucMod = 0;
    if ([8, 1, 9].includes(reduceNumber(lp, false)) || [8, 1, 9].includes(stateAvg)) sucMod += 10;
    if (lp === 8 || lp === 1) sucMod += 6;
    const success = Math.min(99, Math.max(35, Math.round(baseCompatibility * 0.93 + sucMod)));
    
    // 7. Permanent Stay: ruled by Roots, Security (4, 6, 2)
    let stayMod = 0;
    if ([4, 6, 2].includes(reduceNumber(lp, false)) || [4, 6, 2].includes(stateAvg)) stayMod += 8;
    if (lp === 4 || lp === 6) stayMod += 6;
    const permanentStay = Math.min(99, Math.max(30, Math.round(baseCompatibility * 0.91 + stayMod)));
    
    // 8. Settlement: ruled by Domestic Harmony, Family (6, 4, 8)
    let setMod = 0;
    if ([6, 4, 8].includes(reduceNumber(lp, false)) || [6, 4, 8].includes(stateAvg)) setMod += 10;
    if (lp === 6 || lp === 33) setMod += 8; // Master Number 33 represents ultimate home/service harmony
    const settlement = Math.min(99, Math.max(35, Math.round(baseCompatibility * 0.92 + setMod)));
    
    // 9. Miscellaneous: general baseline
    const misc = Math.min(99, Math.max(30, Math.round(baseCompatibility * 0.95 + (Math.sin(baseCompatibility) * 5))));
    
    return {
        career,
        education,
        finance,
        happiness,
        growth,
        success,
        permanentStay,
        settlement,
        misc
    };
}

// --- 7. APPLICATION STATE & STORES ---

const APP_STATE = {
    // Preloaded Family Members in scalable way
    family: [
        { id: 1, name: "First Member", birthdate: "1990-05-15", avatar: "👤", relation: "Self" },
        { id: 2, name: "Second Member", birthdate: "1995-08-22", avatar: "👩‍🚀", relation: "Mother" }
    ],
    
    // Compatibility database
    // Key: State ID, Value: Array of percentages for family members
    compatibility: {},
    
    // Life phase details for all members
    // Key: State ID, Value: Array of life phase objects
    lifePhases: {},
    
    selectedState: "CA", // Default selected state
    activeTab: "dashboard",
    currentFocusPhase: "stay", // stay, grow, study, settle
};

/**
 * Re-calculate all compatibility metrics based on current family state
 */
function recalculateAllCompatibilities() {
    APP_STATE.compatibility = {};
    APP_STATE.lifePhases = {};
    
    // First calculate numerology for all family members
    const familyNumerology = APP_STATE.family.map(member => ({
        id: member.id,
        num: calculateIndividualNumerology(member.name, member.birthdate)
    }));
    
    // Store calculated numerology profiles back to family list for profile cards
    APP_STATE.family.forEach((member, idx) => {
        member.numerology = familyNumerology[idx].num;
    });
    
    // Calculate compatibility for each state
    for (let stateId in US_STATES_DATA) {
        const stateScores = [];
        const statePhases = [];
        
        familyNumerology.forEach(memberData => {
            const score = calculateStateCompatibility(memberData.num, stateId);
            stateScores.push(score);
            
            const phases = calculateLifePhasesBreakdown(memberData.num, stateId, score);
            statePhases.push(phases);
        });
        
        APP_STATE.compatibility[stateId] = stateScores;
        APP_STATE.lifePhases[stateId] = statePhases;
    }
}

function getOrdinalWord(n) {
    const ordinals = ["First", "Second", "Third", "Fourth", "Fifth", "Sixth", "Seventh", "Eighth", "Ninth", "Tenth"];
    return ordinals[n - 1] || `${n}th`;
}

function getAvatarForRelation(relation) {
    const avatars = {
        "self": "👤",
        "father": "👨‍🚀",
        "mother": "👩‍🚀",
        "wife": "👰",
        "husband": "🤵",
        "son": "👦",
        "daughter": "👧",
        "friend": "🤝",
        "grandfather": "🧙‍♂️",
        "grandmother": "👵",
        "spouse": "❤️",
        "uncle": "👨",
        "aunt": "👩",
        "cousin": "🧑",
        "sibling": "🧑‍🚀",
        "custom": "✨"
    };
    const relLower = relation.toLowerCase();
    return avatars[relLower] || "🧑‍🚀";
}

/**
 * Adds a new family member to APP_STATE
 */
function addFamilyMember(name, birthdate, relation) {
    const nextId = APP_STATE.family.length > 0 ? Math.max(...APP_STATE.family.map(m => m.id)) + 1 : 1;
    const defaultName = getOrdinalWord(APP_STATE.family.length + 1) + " Member";
    const avatar = getAvatarForRelation(relation);
    
    const newMember = {
        id: nextId,
        name: name || defaultName,
        birthdate: birthdate || "2000-01-01",
        avatar: avatar,
        relation: relation || "Member",
        expanded: false
    };
    
    APP_STATE.family.push(newMember);
    recalculateAllCompatibilities();
    return newMember;
}

/**
 * Deletes a family member by ID
 */
function deleteFamilyMember(memberId) {
    if (APP_STATE.family.length <= 1) {
        return false;
    }
    
    APP_STATE.family = APP_STATE.family.filter(m => m.id !== memberId);
    recalculateAllCompatibilities();
    return true;
}

// Initialize state
function initEngine() {
    precomputeStateNumerology();
    recalculateAllCompatibilities();
}

// Bind to window for global exposure
if (typeof window !== 'undefined') {
    window.APP_STATE = APP_STATE;
    window.initEngine = initEngine;
    window.recalculateAllCompatibilities = recalculateAllCompatibilities;
    window.calculateIndividualNumerology = calculateIndividualNumerology;
    window.addFamilyMember = addFamilyMember;
    window.deleteFamilyMember = deleteFamilyMember;
    window.getOrdinalWord = getOrdinalWord;
    window.getAvatarForRelation = getAvatarForRelation;
}


;
/**
 * CosmicMatch USA - Visual UI Controller & Chart.js Visualizations
 */

// --- 1. GLOBAL CHART INSTANCES ---
let familyOverviewChart = null;
let phaseDistributionChart = null;
let stateRadarChart = null;
let stateLineChart = null;

// --- 2. ASTRO-NUMEROLOGY EXPLANATION DATABASE ---
const NUMBER_VIBES = {
    1: "the Pioneer, bringing leadership, independence, and strong ambition. Great for initiating new careers.",
    2: "the Collaborator, bringing diplomacy, harmony, intuition, and cooperative energy. Ideal for relationships.",
    3: "the Creator, bringing joy, artistic expression, communication, and vibrant social opportunities.",
    4: "the Builder, bringing structure, dedication, practical foundations, and stable long-term success.",
    5: "the Voyager, bringing versatility, dynamic change, adventure, and strong media and communications.",
    6: "the Nurturer, bringing domestic harmony, responsibility, teaching, and beautiful healing vibes.",
    7: "the Seeker, bringing analytical minds, deep spiritual understanding, technology, and wisdom.",
    8: "the Magnate, bringing financial power, corporate leadership, organization, and material success.",
    9: "the Philanthropist, bringing humanitarian values, creative arts, compassion, and global reach.",
    11: "the Catalyst, a Master Number of high intuition, spiritual illumination, and visionary inspiration.",
    22: "the Architect, a Master Number of practical manifestation and building large-scale projects.",
    33: "the Guide, a Master Number of cosmic service, ultimate harmony, and loving community guidance."
};

/**
 * Returns custom astrology write-up for a state based on its numbers
 */
function getStateAstrologyWriteup(stateId, stateName) {
    const stateNum = STATE_NUMEROLOGY[stateId];
    if (!stateNum) return "";
    
    const pyth = stateNum.pythagorean.destiny;
    const chal = stateNum.chaldean.destiny;
    
    const pythText = NUMBER_VIBES[pyth] || "neutral vibrations.";
    const chalText = NUMBER_VIBES[chal] || "guiding energies.";
    
    return `<strong>${stateName}</strong> vibrates to Pythagorean Number <strong>${pyth}</strong> and Chaldean Number <strong>${5}</strong>. 
    Under the Pythagorean modern system, it carries the vibration of <strong>${pythText}</strong> 
    Meanwhile, the ancient Chaldean sound vibration resonates to <strong>${chalText}</strong> 
    This combined signature offers a highly unique pathway for growth, career, and stability, matching differently to each family member's core life path number.`;
}

// --- 3. DYNAMIC DOM RENDERERS ---

/**
 * Render Family Cards in Sidebar
 */
function renderFamilySidebar() {
    const container = document.getElementById("family-list-container");
    if (!container) return;
    
    container.innerHTML = "";
    
    APP_STATE.family.forEach((member, index) => {
        const num = member.numerology;
        const score = APP_STATE.compatibility[APP_STATE.selectedState] ? APP_STATE.compatibility[APP_STATE.selectedState][index] : 75;
        
        const card = document.createElement("div");
        card.className = "family-card animate-slide-in";
        card.style.animationDelay = `${index * 0.05}s`;
        card.setAttribute("data-id", member.id);
        
        // Expansion state
        const isExpanded = member.expanded;
        if (isExpanded) {
            card.classList.add("expanded");
        }
        
        const isStandardRelation = ["Self", "Father", "Mother", "Wife", "Son", "Daughter", "Friend"].includes(member.relation);
        
        card.innerHTML = `
            <div class="card-summary">
                <div class="card-summary-left">
                    <div class="avatar-sphere">${member.avatar}</div>
                    <div class="profile-info">
                        <h3>${member.name}</h3>
                        <p>${member.relation} • LP ${num.lifePath}</p>
                    </div>
                </div>
                <div class="card-score-pill">
                    <span class="label">Affinity</span>
                    <span class="val">${score}%</span>
                </div>
            </div>
            
            ${isExpanded ? `
            <div class="card-details-expanded" onclick="event.stopPropagation()">
                <div class="form-group">
                    <label>Full Name</label>
                    <input type="text" value="${member.name}" data-field="name" class="member-input" style="width:100%;">
                </div>
                <div class="form-group">
                    <label>Birth Date</label>
                    <input type="date" value="${member.birthdate}" data-field="birthdate" class="member-input" style="width:100%;">
                </div>
                <div class="form-group">
                    <label>Relation</label>
                    <select data-field="relation-select" class="custom-select member-select-relation" data-id="${member.id}" style="background: var(--input-bg); border: 1px solid var(--input-border); padding: 10px; border-radius: 8px; font-weight:normal; width:100%; color:var(--text-primary);">
                        <option value="Self" ${member.relation === "Self" ? "selected" : ""}>Self</option>
                        <option value="Father" ${member.relation === "Father" ? "selected" : ""}>Father</option>
                        <option value="Mother" ${member.relation === "Mother" ? "selected" : ""}>Mother</option>
                        <option value="Wife" ${member.relation === "Wife" ? "selected" : ""}>Wife</option>
                        <option value="Son" ${member.relation === "Son" ? "selected" : ""}>Son</option>
                        <option value="Daughter" ${member.relation === "Daughter" ? "selected" : ""}>Daughter</option>
                        <option value="Friend" ${member.relation === "Friend" ? "selected" : ""}>Friend</option>
                        <option value="Custom" ${!isStandardRelation ? "selected" : ""}>Custom</option>
                    </select>
                </div>
                <div class="form-group member-custom-relation-wrapper" data-id="${member.id}" style="display: ${!isStandardRelation ? "flex" : "none"};">
                    <label>Custom Relation</label>
                    <input type="text" value="${!isStandardRelation ? member.relation : ""}" placeholder="e.g. Spouse, Grandfather, Sibling" data-field="custom-relation" class="member-input custom-relation-input" style="width:100%;">
                </div>
                
                <div class="numerology-badge-grid">
                    <div class="num-badge">
                        <span class="lbl">Life Path</span>
                        <span class="num">${num.lifePath}</span>
                    </div>
                    <div class="num-badge">
                        <span class="lbl">Destiny</span>
                        <span class="num">${num.pythagorean.destiny}</span>
                    </div>
                    <div class="num-badge">
                        <span class="lbl">Soul Urge</span>
                        <span class="num">${num.pythagorean.soulUrge}</span>
                    </div>
                </div>
                
                <button class="filter-btn delete-member-btn" data-id="${member.id}" style="width: 100%; margin-top: 10px; border-color: var(--color-challenging); color: var(--color-challenging); background: rgba(255, 74, 90, 0.05); display: flex; align-items: center; justify-content: center; gap: 6px; padding: 10px; border-radius: 8px;">
                    <i data-lucide="trash-2" style="width:14px; height:14px;"></i> Delete Astro-Profile
                </button>
            </div>
            ` : ""}
        `;
        
        // Toggle expand
        card.addEventListener("click", () => {
            APP_STATE.family.forEach((m, idx) => {
                m.expanded = (idx === index) ? !m.expanded : false;
            });
            renderFamilySidebar();
            bindSidebarInputListeners();
        });
        
        // Bind delete profile action
        const deleteBtn = card.querySelector(".delete-member-btn");
        if (deleteBtn) {
            deleteBtn.addEventListener("click", (e) => {
                e.stopPropagation(); // prevent card toggles
                const memberId = parseInt(deleteBtn.getAttribute("data-id"), 10);
                
                if (APP_STATE.family.length <= 1) {
                    alert("Your cosmos requires at least one family member.");
                    return;
                }
                
                if (confirm(`Remove ${member.name} from the family calculations?`)) {
                    deleteFamilyMember(memberId);
                    
                    // Update selectors, tables, dashboard, maps
                    updateDynamicDropdowns();
                    updateDashboardStats();
                    colorSVGMap();
                    renderRankingsTable();
                    renderInsightsTab();
                    
                    updateOverviewChart();
                    updatePhaseDistributionChart();
                    renderFamilySidebar();
                }
            });
        }
        
        container.appendChild(card);
    });
}

function bindSidebarInputListeners() {
    const inputs = document.querySelectorAll(".member-input");
    inputs.forEach(input => {
        input.addEventListener("input", (e) => {
            const cardEl = e.target.closest(".family-card");
            const memberId = parseInt(cardEl.getAttribute("data-id"), 10);
            const field = e.target.getAttribute("data-field");
            const val = e.target.value;
            
            // Find and update member
            const member = APP_STATE.family.find(m => m.id === memberId);
            if (member) {
                if (field === "custom-relation") {
                    member.relation = val || "Custom";
                    member.avatar = getAvatarForRelation(member.relation);
                    
                    const avatarEl = cardEl.querySelector(".avatar-sphere");
                    if (avatarEl) avatarEl.innerText = member.avatar;
                    
                    const subtitleEl = cardEl.querySelector(".profile-info p");
                    if (subtitleEl) subtitleEl.innerText = `${member.relation} • LP ${member.numerology.lifePath}`;
                } else if (field === "name") {
                    member.name = val || "New Astro Soul";
                    const titleEl = cardEl.querySelector(".profile-info h3");
                    if (titleEl) titleEl.innerText = member.name;
                } else {
                    member[field] = val;
                }
                
                // Recalculate
                recalculateAllCompatibilities();
                
                // Refresh visuals in real-time!
                updateDashboardStats();
                colorSVGMap();
                renderRankingsTable();
                renderInsightsTab();
                
                // Update charts if they exist
                updateOverviewChart();
                updatePhaseDistributionChart();
                if (document.getElementById("state-modal").classList.contains("active")) {
                    renderStateModalDetails(APP_STATE.selectedState);
                }
            }
        });
        
        // Prevent key expansion clicks from bubbling
        input.addEventListener("click", (e) => e.stopPropagation());
    });

    const relationSelects = document.querySelectorAll(".member-select-relation");
    relationSelects.forEach(select => {
        select.addEventListener("change", (e) => {
            const memberId = parseInt(select.getAttribute("data-id"), 10);
            const val = select.value;
            const cardEl = select.closest(".family-card");
            const wrapper = cardEl.querySelector(".member-custom-relation-wrapper");
            const customInput = cardEl.querySelector(".custom-relation-input");
            
            const member = APP_STATE.family.find(m => m.id === memberId);
            if (member) {
                if (val === "Custom") {
                    wrapper.style.display = "flex";
                    member.relation = customInput.value.trim() || "Custom";
                } else {
                    wrapper.style.display = "none";
                    member.relation = val;
                }
                member.avatar = getAvatarForRelation(member.relation);
                
                recalculateAllCompatibilities();
                updateDynamicDropdowns();
                updateDashboardStats();
                colorSVGMap();
                renderRankingsTable();
                renderInsightsTab();
                updateOverviewChart();
                updatePhaseDistributionChart();
                
                // Re-render select change to update the avatar sphere and subtitle instantly
                renderFamilySidebar();
                bindSidebarInputListeners();
            }
        });
        select.addEventListener("click", (e) => e.stopPropagation());
    });
}

/**
 * Updates stats widgets on the top of the dashboard
 */
function updateDashboardStats() {
    // Find best state
    let bestStateId = "CA";
    let bestScore = 0;
    let combinedSum = 0;
    let statesCount = 0;
    
    for (let stateId in APP_STATE.compatibility) {
        const scores = APP_STATE.compatibility[stateId];
        const avg = Math.round(scores.reduce((sum, s) => sum + s, 0) / scores.length);
        combinedSum += avg;
        statesCount++;
        
        if (avg > bestScore) {
            bestScore = avg;
            bestStateId = stateId;
        }
    }
    
    const overallAvg = Math.round(combinedSum / statesCount);
    const bestStateName = US_STATES_DATA[bestStateId] ? US_STATES_DATA[bestStateId].name : bestStateId;
    
    document.getElementById("dash-best-state-name").innerText = bestStateName;
    document.getElementById("dash-best-state-score").innerText = `Match Score: ${bestScore}%`;
    document.getElementById("dash-family-average").innerText = `${overallAvg}%`;
    
    // Check master numbers
    const activeMasters = [];
    APP_STATE.family.forEach(m => {
        const lp = m.numerology.lifePath;
        if ([11, 22, 33].includes(lp) && !activeMasters.includes(lp)) {
            activeMasters.push(lp);
        }
    });
    
    const mastersEl = document.getElementById("dash-master-energies");
    if (activeMasters.length > 0) {
        mastersEl.innerText = activeMasters.join(", ");
        mastersEl.style.color = "var(--color-exceptional)";
    } else {
        mastersEl.innerText = "None Active";
        mastersEl.style.color = "var(--text-primary)";
    }
    
    // Render Top & Challenging Lists
    renderDashboardLists();
}

/**
 * Renders top 5 and bottom 5 states lists in the dashboard
 */
function renderDashboardLists() {
    const topContainer = document.getElementById("dash-top-states-container");
    const bottomContainer = document.getElementById("dash-bottom-states-container");
    if (!topContainer || !bottomContainer) return;
    
    // Compile list with averages
    const list = [];
    for (let id in APP_STATE.compatibility) {
        const scores = APP_STATE.compatibility[id];
        const avg = Math.round(scores.reduce((sum, s) => sum + s, 0) / scores.length);
        list.push({ id, avg, name: US_STATES_DATA[id].name, capital: US_STATES_DATA[id].capital });
    }
    
    // Sort
    list.sort((a, b) => b.avg - a.avg);
    
    // Top 5
    topContainer.innerHTML = "";
    list.slice(0, 5).forEach((state, index) => {
        const row = document.createElement("div");
        row.className = "state-summary-row";
        row.innerHTML = `
            <div class="row-left">
                <div class="state-rank-badge top-1">${index + 1}</div>
                <div>
                    <h4>${state.name}</h4>
                    <p class="cap">Capital: ${state.capital}</p>
                </div>
            </div>
            <div class="row-right">
                <div class="score-badge exceptional">${state.avg}%</div>
            </div>
        `;
        row.addEventListener("click", () => openStateModal(state.id));
        topContainer.appendChild(row);
    });
    
    // Bottom 5
    bottomContainer.innerHTML = "";
    list.slice(-5).reverse().forEach((state, index) => {
        const row = document.createElement("div");
        row.className = "state-summary-row";
        row.innerHTML = `
            <div class="row-left">
                <div class="state-rank-badge">${index + 1}</div>
                <div>
                    <h4>${state.name}</h4>
                    <p class="cap">Capital: ${state.capital}</p>
                </div>
            </div>
            <div class="row-right">
                <div class="score-badge challenging">${state.avg}%</div>
            </div>
        `;
        row.addEventListener("click", () => openStateModal(state.id));
        bottomContainer.appendChild(row);
    });
}

// --- 4. INTERACTIVE USA VECTOR MAP SETUP ---

/**
 * Renders and injects SVG paths dynamically from state_data.js
 */
function initializeSVGMap() {
    const svgEl = document.getElementById("usa-svg");
    if (!svgEl) return;
    
    svgEl.innerHTML = "";
    
    for (let id in US_STATES_DATA) {
        const state = US_STATES_DATA[id];
        const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
        path.setAttribute("id", `map-state-${id}`);
        path.setAttribute("d", state.path);
        path.setAttribute("class", "state-path");
        
        // Add events
        path.addEventListener("mouseover", (e) => showMapTooltip(e, id));
        path.addEventListener("mousemove", (e) => positionMapTooltip(e));
        path.addEventListener("mouseout", () => hideMapTooltip());
        path.addEventListener("click", () => openStateModal(id));
        
        svgEl.appendChild(path);
    }
    
    colorSVGMap();
}

/**
 * Colors the SVG map paths based on the selected family member or combined average
 */
function colorSVGMap() {
    const selector = document.getElementById("map-viewer-select");
    if (!selector) return;
    
    const mode = selector.value;
    
    for (let id in US_STATES_DATA) {
        const path = document.getElementById(`map-state-${id}`);
        if (!path) continue;
        
        // Reset classes
        path.removeAttribute("class");
        path.setAttribute("class", "state-path");
        
        const scores = APP_STATE.compatibility[id];
        let score = 75;
        
        if (mode === "combined") {
            score = Math.round(scores.reduce((sum, s) => sum + s, 0) / scores.length);
        } else {
            const memberId = parseInt(mode, 10);
            const memberIdx = APP_STATE.family.findIndex(m => m.id === memberId);
            score = (memberIdx !== -1) ? scores[memberIdx] : 75;
        }
        
        // Apply color bands
        if (score < 55) {
            path.classList.add("challenging");
        } else if (score >= 55 && score < 75) {
            path.classList.add("neutral");
        } else if (score >= 75 && score < 85) {
            path.classList.add("compatible");
        } else {
            path.classList.add("exceptional");
        }
    }
}

function showMapTooltip(e, id) {
    const infoBox = document.getElementById("info-box");
    if (!infoBox) return;
    
    const state = US_STATES_DATA[id];
    const scores = APP_STATE.compatibility[id];
    const avg = Math.round(scores.reduce((sum, s) => sum + s, 0) / scores.length);
    
    infoBox.classList.remove("hide");
    infoBox.style.display = "block";
    
    infoBox.innerHTML = `
        <h3>🇺🇸 ${state.name} (${state.id})</h3>
        <div class="info-body">
            <p>Capital: ${state.capital}</p>
            <p style="margin-top: 6px; font-weight: 700; color: var(--color-compatible);">Family Score: ${avg}%</p>
            <p style="font-size: 9px; color: var(--text-muted); margin-top: 4px;">Click to view cosmic radar</p>
        </div>
    `;
    
    positionMapTooltip(e);
}

function positionMapTooltip(e) {
    const infoBox = document.getElementById("info-box");
    if (!infoBox || infoBox.classList.contains("hide")) return;
    
    // Position offset from mouse
    const x = e.clientX + 15;
    const y = e.clientY + 15;
    
    // Keep within bounds
    const boxRect = infoBox.getBoundingClientRect();
    let left = x;
    let top = y;
    
    if (left + boxRect.width > window.innerWidth) {
        left = e.clientX - boxRect.width - 15;
    }
    if (top + boxRect.height > window.innerHeight) {
        top = e.clientY - boxRect.height - 15;
    }
    
    infoBox.style.left = `${left}px`;
    infoBox.style.top = `${top}px`;
}

function hideMapTooltip() {
    const infoBox = document.getElementById("info-box");
    if (infoBox) {
        infoBox.classList.add("hide");
        infoBox.style.display = "none";
    }
}

// --- 5. SORTABLE STATE RANKINGS GRID ---

let currentSortField = "avg";
let currentSortOrder = "desc"; // desc or asc

function renderRankingsTable() {
    const tableEl = document.getElementById("rankings-table-el");
    const searchInput = document.getElementById("state-search-input");
    if (!tableEl) return;
    
    const query = searchInput ? searchInput.value.toLowerCase().trim() : "";
    
    // 1. Rebuild the Table Header (thead) dynamically
    let thead = tableEl.querySelector("thead");
    if (!thead) {
        thead = document.createElement("thead");
        tableEl.appendChild(thead);
    }
    
    let headCells = `<tr><th data-sort="name" class="${currentSortField === 'name' ? (currentSortOrder === 'asc' ? 'sort-asc' : 'sort-desc') : ''}">US State <i data-lucide="chevrons-up-down"></i></th>`;
    
    APP_STATE.family.forEach((member) => {
        const firstName = member.name.split(" ")[0];
        const isSorted = currentSortField === member.id.toString();
        const cls = isSorted ? (currentSortOrder === 'asc' ? 'sort-asc' : 'sort-desc') : '';
        headCells += `<th data-sort="${member.id}" class="${cls}">${firstName} % <i data-lucide="chevrons-up-down"></i></th>`;
    });
    
    const isAvgSorted = currentSortField === "avg";
    const avgCls = isAvgSorted ? (currentSortOrder === 'asc' ? 'sort-asc' : 'sort-desc') : '';
    headCells += `<th data-sort="avg" class="highlight-col ${avgCls}">Family Avg % <i data-lucide="chevrons-up-down"></i></th></tr>`;
    thead.innerHTML = headCells;
    
    // Bind listeners to new headers
    thead.querySelectorAll("th").forEach(th => {
        th.addEventListener("click", () => {
            const field = th.getAttribute("data-sort");
            if (currentSortField === field) {
                currentSortOrder = currentSortOrder === "desc" ? "asc" : "desc";
            } else {
                currentSortField = field;
                currentSortOrder = "desc";
            }
            renderRankingsTable();
        });
    });
    
    // 2. Rebuild the Table Body (tbody)
    let tbody = document.getElementById("rankings-table-body");
    if (!tbody) {
        tbody = document.createElement("tbody");
        tbody.setAttribute("id", "rankings-table-body");
        tableEl.appendChild(tbody);
    }
    
    // Compile table dataset
    let rowsData = [];
    for (let id in US_STATES_DATA) {
        const state = US_STATES_DATA[id];
        const scores = APP_STATE.compatibility[id];
        const avg = Math.round(scores.reduce((sum, s) => sum + s, 0) / scores.length);
        
        // Search filter
        if (query && !state.name.toLowerCase().includes(query) && !state.id.toLowerCase().includes(query)) {
            continue;
        }
        
        rowsData.push({
            id,
            name: state.name,
            capital: state.capital,
            scores: scores,
            avg: avg
        });
    }
    
    // Apply sorting
    rowsData.sort((a, b) => {
        let valA, valB;
        
        if (currentSortField === "name") {
            valA = a.name;
            valB = b.name;
        } else if (currentSortField === "avg") {
            valA = a.avg;
            valB = b.avg;
        } else {
            const memberId = parseInt(currentSortField, 10);
            const memberIdx = APP_STATE.family.findIndex(m => m.id === memberId);
            valA = (memberIdx !== -1) ? a.scores[memberIdx] : 75;
            valB = (memberIdx !== -1) ? b.scores[memberIdx] : 75;
        }
        
        if (valA < valB) return currentSortOrder === "asc" ? -1 : 1;
        if (valA > valB) return currentSortOrder === "asc" ? 1 : -1;
        return 0;
    });
    
    tbody.innerHTML = "";
    
    if (rowsData.length === 0) {
        tbody.innerHTML = `<tr><td colspan="${APP_STATE.family.length + 2}" style="text-align: center; color: var(--text-secondary); padding: 40px;">No states match your search query.</td></tr>`;
        return;
    }
    
    rowsData.forEach(row => {
        const tr = document.createElement("tr");
        tr.addEventListener("click", () => openStateModal(row.id));
        
        const getCls = (score) => {
            if (score < 55) return "challenging";
            if (score >= 55 && score < 75) return "neutral";
            if (score >= 75 && score < 85) return "compatible";
            return "exceptional";
        };
        
        let rowCells = `<td><strong>${row.name}</strong> <span style="color: var(--text-secondary); font-size:11px;">(${row.id})</span></td>`;
        
        APP_STATE.family.forEach((member, index) => {
            const score = row.scores[index];
            rowCells += `<td><span class="mini-score-val ${getCls(score)}">${score}%</span></td>`;
        });
        
        rowCells += `<td class="highlight-col"><span class="mini-score-val ${getCls(row.avg)}">${row.avg}%</span></td>`;
        tr.innerHTML = rowCells;
        tbody.appendChild(tr);
    });
    
    lucide.createIcons();
}

function setupTableSorting() {
    // Left as no-op since headers bind listeners dynamically in renderRankingsTable()
}

// --- 6. COSMIC INSIGHTS GOAL PHASES TAB ---

const PHASE_DETAILS = {
    stay: {
        title: "🏡 Fortunate to Stay & Plant Roots",
        concept: "Stability, security, and residential energy alignment.",
        description: "Permanent Stay focuses on grounding vibrations (ruled by numbers 4, 6, and 2). This phase isolates a state's domestic harmony, structural security, and community compatibility. Top-ranking states here offer an exceptionally peaceful vibe where families can settle long-term and establish deep emotional roots.",
        metricIndex: "permanentStay" // maps to lifePhases database keys
    },
    grow: {
        title: "🌱 Fortunate to Grow & Succeed",
        concept: "Personal growth, self-discovery, travel, and milestones.",
        description: "Growth & Success captures the energetic expansion driven by versatility, adaptability, travel, and strong manifestation vibrations (ruled by numbers 5, 9, and 3). These states resonate with high energy, frequent dynamic changes, and massive growth, giving family members the courage to transform and succeed.",
        metricIndex: "growth"
    },
    study: {
        title: "🎓 Fortunate to Study & Learn",
        concept: "Intellect, logic, education, and knowledge acquisition.",
        description: "Education is driven by analytical, seek-and-find vibrations (ruled by numbers 5, 7, and 3). It tracks the suitability of states for academic success, schools, focus, and philosophical exploration. Leading states here provide quiet, intellectually stimulating cosmic backdrops ideal for studying and personal focus.",
        metricIndex: "education"
    },
    settle: {
        title: "💼 Fortunate to Settle & Advance Career",
        concept: "Career growth, financial prosperity, and material accomplishment.",
        description: "Settle and Career isolates leadership, ambition, organization, and material success numbers (ruled by numbers 1, 8, and 9). It identifies which states hold strong planetary forces for professional climb, business creation, and abundance, showing where combined family energies match high economic success.",
        metricIndex: "settlement"
    }
};

function renderInsightsTab() {
    const descBox = document.getElementById("phase-description-box");
    const container = document.getElementById("phase-states-container");
    if (!descBox || !container) return;
    
    const phaseKey = APP_STATE.currentFocusPhase;
    const info = PHASE_DETAILS[phaseKey];
    
    // 1. Render Description Box
    descBox.innerHTML = `
        <div class="phase-desc-header">
            <span class="icon" style="font-size:24px;">${phaseKey === "stay" ? "🏡" : phaseKey === "grow" ? "🌱" : phaseKey === "study" ? "🎓" : "💼"}</span>
            <div>
                <h3>${info.title}</h3>
                <p style="font-size:11px; text-transform:uppercase; color:var(--text-muted);">${info.concept}</p>
            </div>
        </div>
        <p>${info.description}</p>
    `;
    
    // 2. Render ranking states for this phase
    // Compile averages for this specific phase
    const phaseStates = [];
    const metric = info.metricIndex;
    
    for (let id in APP_STATE.lifePhases) {
        const phases = APP_STATE.lifePhases[id]; // array of 5 phase objects
        const avg = Math.round(phases.reduce((sum, p) => sum + p[metric], 0) / phases.length);
        
        phaseStates.push({
            id,
            name: US_STATES_DATA[id].name,
            capital: US_STATES_DATA[id].capital,
            score: avg
        });
    }
    
    phaseStates.sort((a, b) => b.score - a.score);
    
    container.innerHTML = "";
    
    phaseStates.slice(0, 5).forEach((state, index) => {
        const row = document.createElement("div");
        row.className = "state-summary-row";
        row.innerHTML = `
            <div class="row-left">
                <div class="state-rank-badge top-1">${index + 1}</div>
                <div>
                    <h4>${state.name}</h4>
                    <p class="cap">Capital: ${state.capital}</p>
                </div>
            </div>
            <div class="row-right">
                <div class="score-badge exceptional">${state.score}%</div>
            </div>
        `;
        row.addEventListener("click", () => openStateModal(state.id));
        container.appendChild(row);
    });
    
    // Update Phase Distribution Doughnut Chart
    updatePhaseDistributionChart();
}

function setupInsightsTabs() {
    const btns = document.querySelectorAll(".phase-tab-btn");
    btns.forEach(btn => {
        btn.addEventListener("click", () => {
            btns.forEach(b => b.classList.remove("active"));
            btn.classList.add("active");
            
            APP_STATE.currentFocusPhase = btn.getAttribute("data-phase");
            
            // Set header title
            const listTitle = document.getElementById("phase-list-title");
            if (APP_STATE.currentFocusPhase === "stay") listTitle.innerText = "Top States for Permanent Stay";
            if (APP_STATE.currentFocusPhase === "grow") listTitle.innerText = "Top States for Growth & Success";
            if (APP_STATE.currentFocusPhase === "study") listTitle.innerText = "Top States for Education & Study";
            if (APP_STATE.currentFocusPhase === "settle") listTitle.innerText = "Top States for Settlement & Career";
            
            renderInsightsTab();
        });
    });
}

// --- 7. DETAILED STATE SLIDE-OUT DRAWER / MODAL ---

function openStateModal(stateId) {
    APP_STATE.selectedState = stateId;
    
    const modal = document.getElementById("state-modal");
    modal.classList.remove("hide");
    modal.classList.add("active");
    modal.style.display = "flex";
    
    renderStateModalDetails(stateId);
}

function closeStateModal() {
    const modal = document.getElementById("state-modal");
    modal.classList.remove("active");
    modal.classList.add("hide");
    
    // Hide after animation finishes
    setTimeout(() => {
        if (modal.classList.contains("hide")) {
            modal.style.display = "none";
        }
    }, 300);
}

function renderStateModalDetails(stateId) {
    const state = US_STATES_DATA[stateId];
    if (!state) return;
    
    const scores = APP_STATE.compatibility[stateId];
    const stateNum = STATE_NUMEROLOGY[stateId];
    
    document.getElementById("modal-state-name").innerText = state.name;
    document.getElementById("modal-state-capital").innerText = `Capital: ${state.capital} • ID: ${stateId}`;
    document.getElementById("modal-scorecard-state-name").innerText = state.name;
    
    document.getElementById("modal-pyth-vibe").innerText = stateNum.pythagorean.destiny;
    document.getElementById("modal-chal-vibe").innerText = stateNum.chaldean.destiny;
    
    // Set write-up
    document.getElementById("modal-astro-analysis").innerHTML = getStateAstrologyWriteup(stateId, state.name);
    
    // Fill scorecard mini list
    const scorecard = document.getElementById("modal-family-scorecard");
    scorecard.innerHTML = "";
    
    APP_STATE.family.forEach((member, index) => {
        const score = scores[index];
        
        const getCls = (s) => {
            if (s < 55) return "challenging";
            if (s >= 55 && s < 75) return "neutral";
            if (s >= 75 && s < 85) return "compatible";
            return "exceptional";
        };
        
        const card = document.createElement("div");
        card.className = "scorecard-mini-card";
        card.innerHTML = `
            <div class="name">${member.name.split(" ")[0]}</div>
            <div class="score ${getCls(score)}">${score}%</div>
            <div style="font-size:8px; color:var(--text-muted); text-transform:uppercase;">${member.relation}</div>
        `;
        scorecard.appendChild(card);
    });
    
    // Render Modal charts
    renderModalRadarChart(stateId);
    renderModalLineChart(stateId);
}

function setupModalTabs() {
    const btns = document.querySelectorAll(".chart-tab-btn");
    btns.forEach(btn => {
        btn.addEventListener("click", () => {
            btns.forEach(b => b.classList.remove("active"));
            btn.classList.add("active");
            
            const target = btn.getAttribute("data-chart");
            
            document.getElementById("modal-chart-radar-container").classList.remove("active");
            document.getElementById("modal-chart-line-container").classList.remove("active");
            
            document.getElementById(`modal-chart-${target}-container`).classList.add("active");
        });
    });
}

// --- 8. CHARTJS BUILDERS AND INITIALIZATIONS ---

/**
 * Get CSS theme-dependent color tokens for Chart config
 */
function getChartColors() {
    const isDark = document.body.classList.contains("dark-theme");
    return {
        grid: isDark ? "rgba(255, 255, 255, 0.08)" : "rgba(100, 80, 150, 0.12)",
        ticks: isDark ? "#a49fc6" : "#585375",
        tooltipBg: isDark ? "rgba(15, 12, 30, 0.9)" : "rgba(255, 255, 255, 0.95)",
        tooltipBorder: isDark ? "rgba(255, 255, 255, 0.15)" : "rgba(100, 80, 150, 0.25)",
        tooltipText: isDark ? "#f3f2f8" : "#1e1a34"
    };
}

/**
 * Dashboard top-states bar chart
 */
function initOverviewChart() {
    const ctx = document.getElementById("familyOverviewChart");
    if (!ctx) return;
    
    // Get Top 10 States with averages
    const list = [];
    for (let id in APP_STATE.compatibility) {
        const scores = APP_STATE.compatibility[id];
        const avg = Math.round(scores.reduce((sum, s) => sum + s, 0) / scores.length);
        list.push({ name: US_STATES_DATA[id].name, avg: avg });
    }
    list.sort((a, b) => b.avg - a.avg);
    const top10 = list.slice(0, 10);
    
    const colors = getChartColors();
    
    familyOverviewChart = new Chart(ctx, {
        type: 'bar',
        data: {
            labels: top10.map(s => s.name),
            datasets: [{
                label: 'Combined Affinity Score (%)',
                data: top10.map(s => s.avg),
                backgroundColor: 'rgba(0, 240, 255, 0.4)',
                borderColor: '#00f0ff',
                borderWidth: 2,
                borderRadius: 6,
                hoverBackgroundColor: 'rgba(189, 94, 255, 0.6)',
                hoverBorderColor: '#bd5eff'
            }]
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: { display: false },
                tooltip: {
                    backgroundColor: colors.tooltipBg,
                    borderColor: colors.tooltipBorder,
                    borderWidth: 1,
                    titleColor: colors.tooltipText,
                    bodyColor: colors.tooltipText,
                    padding: 12
                }
            },
            scales: {
                x: {
                    grid: { display: false },
                    ticks: { color: colors.ticks, font: { family: 'Inter', size: 11 } }
                },
                y: {
                    grid: { color: colors.grid },
                    ticks: { color: colors.ticks, font: { family: 'Inter', size: 11 } },
                    min: 40,
                    max: 100
                }
            }
        }
    });
}

function updateOverviewChart() {
    if (!familyOverviewChart) return;
    
    const list = [];
    for (let id in APP_STATE.compatibility) {
        const scores = APP_STATE.compatibility[id];
        const avg = Math.round(scores.reduce((sum, s) => sum + s, 0) / scores.length);
        list.push({ name: US_STATES_DATA[id].name, avg: avg });
    }
    list.sort((a, b) => b.avg - a.avg);
    const top10 = list.slice(0, 10);
    
    familyOverviewChart.data.labels = top10.map(s => s.name);
    familyOverviewChart.data.datasets[0].data = top10.map(s => s.avg);
    familyOverviewChart.update();
}

/**
 * Insights tab doughnut chart
 */
function initPhaseDistributionChart() {
    const ctx = document.getElementById("phaseDistributionChart");
    if (!ctx) return;
    
    const colors = getChartColors();
    
    phaseDistributionChart = new Chart(ctx, {
        type: 'doughnut',
        data: {
            labels: ['Harmonious (>75%)', 'Neutral (55%-75%)', 'Challenging (<55%)'],
            datasets: [{
                data: [0, 0, 0],
                backgroundColor: [
                    'rgba(189, 94, 255, 0.65)',
                    'rgba(255, 183, 0, 0.65)',
                    'rgba(255, 74, 90, 0.65)'
                ],
                borderColor: [
                    '#bd5eff',
                    '#ffb700',
                    '#ff4a5a'
                ],
                borderWidth: 2
            }]
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    position: 'bottom',
                    labels: { color: colors.ticks, font: { family: 'Inter', size: 11 } }
                },
                tooltip: {
                    backgroundColor: colors.tooltipBg,
                    borderColor: colors.tooltipBorder,
                    borderWidth: 1,
                    titleColor: colors.tooltipText,
                    bodyColor: colors.tooltipText
                }
            },
            cutout: '65%'
        }
    });
    
    updatePhaseDistributionChart();
}

function updatePhaseDistributionChart() {
    if (!phaseDistributionChart) return;
    
    const phaseKey = APP_STATE.currentFocusPhase;
    const metric = PHASE_DETAILS[phaseKey].metricIndex;
    
    let high = 0;
    let mid = 0;
    let low = 0;
    
    for (let id in APP_STATE.lifePhases) {
        const phases = APP_STATE.lifePhases[id];
        const avg = Math.round(phases.reduce((sum, p) => sum + p[metric], 0) / phases.length);
        
        if (avg >= 75) high++;
        else if (avg >= 55 && avg < 75) mid++;
        else low++;
    }
    
    phaseDistributionChart.data.datasets[0].data = [high, mid, low];
    phaseDistributionChart.update();
}

/**
 * Modal state-vibe Radar chart
 */
function renderModalRadarChart(stateId) {
    const ctx = document.getElementById("stateRadarChart");
    if (!ctx) return;
    
    const statePhases = APP_STATE.lifePhases[stateId]; // array of 5 phase objects
    if (!statePhases) return;
    
    // Average scores for each phase
    const keys = ["career", "education", "finance", "happiness", "growth", "success", "permanentStay", "settlement"];
    const labels = ["Career", "Education", "Finance", "Happiness", "Growth", "Success", "Perm. Stay", "Settlement"];
    
    const avgScores = keys.map(k => {
        return Math.round(statePhases.reduce((sum, p) => sum + p[k], 0) / statePhases.length);
    });
    
    const colors = getChartColors();
    
    if (stateRadarChart) {
        stateRadarChart.destroy();
    }
    
    stateRadarChart = new Chart(ctx, {
        type: 'radar',
        data: {
            labels: labels,
            datasets: [{
                label: 'Combined Family Vibe Score (%)',
                data: avgScores,
                backgroundColor: 'rgba(189, 94, 255, 0.25)',
                borderColor: '#bd5eff',
                pointBackgroundColor: '#00f0ff',
                pointBorderColor: '#fff',
                borderWidth: 2
            }]
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: { display: false },
                tooltip: {
                    backgroundColor: colors.tooltipBg,
                    borderColor: colors.tooltipBorder,
                    borderWidth: 1,
                    titleColor: colors.tooltipText,
                    bodyColor: colors.tooltipText
                }
            },
            scales: {
                r: {
                    angleLines: { color: colors.grid },
                    grid: { color: colors.grid },
                    pointLabels: { color: colors.ticks, font: { family: 'Outfit', size: 10 } },
                    ticks: { display: false },
                    min: 30,
                    max: 100
                }
            }
        }
    });
}

/**
 * Modal State-member alignment curved Line chart
 */
function renderModalLineChart(stateId) {
    const ctx = document.getElementById("stateLineChart");
    if (!ctx) return;
    
    const statePhases = APP_STATE.lifePhases[stateId];
    if (!statePhases) return;
    
    const keys = ["career", "education", "finance", "happiness", "growth", "success", "permanentStay", "settlement"];
    const labels = ["Career", "Edu", "Fin", "Hap", "Gro", "Suc", "Stay", "Settle"];
    
    // Compile datasets for each family member
    const colorsList = ["#bd5eff", "#00f0ff", "#ffb700", "#ff4a5a", "#00ff66"];
    const datasets = APP_STATE.family.map((member, idx) => {
        const scores = keys.map(k => statePhases[idx][k]);
        return {
            label: member.name.split(" ")[0],
            data: scores,
            borderColor: colorsList[idx],
            backgroundColor: 'transparent',
            borderWidth: 2,
            tension: 0.3,
            pointRadius: 3
        };
    });
    
    const colors = getChartColors();
    
    if (stateLineChart) {
        stateLineChart.destroy();
    }
    
    stateLineChart = new Chart(ctx, {
        type: 'line',
        data: {
            labels: labels,
            datasets: datasets
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    position: 'bottom',
                    labels: { color: colors.ticks, font: { family: 'Inter', size: 10 }, boxWidth: 12 }
                },
                tooltip: {
                    backgroundColor: colors.tooltipBg,
                    borderColor: colors.tooltipBorder,
                    borderWidth: 1,
                    titleColor: colors.tooltipText,
                    bodyColor: colors.tooltipText
                }
            },
            scales: {
                x: {
                    grid: { display: false },
                    ticks: { color: colors.ticks, font: { family: 'Inter', size: 10 } }
                },
                y: {
                    grid: { color: colors.grid },
                    ticks: { color: colors.ticks, font: { family: 'Inter', size: 10 } },
                    min: 30,
                    max: 100
                }
            }
        }
    });
}

// --- 9. GLOBAL TAB SWITCHER ---
function setupTabNavigation() {
    const btns = document.querySelectorAll(".nav-btn");
    const panels = document.querySelectorAll(".tab-panel");
    
    btns.forEach(btn => {
        btn.addEventListener("click", () => {
            btns.forEach(b => b.classList.remove("active"));
            btn.classList.add("active");
            
            const target = btn.getAttribute("data-tab");
            
            panels.forEach(p => p.classList.remove("active"));
            document.getElementById(`tab-${target}`).classList.add("active");
            
            // Re-render components if needed when appearing
            if (target === "dashboard") {
                updateDashboardStats();
                setTimeout(() => updateOverviewChart(), 50);
            }
            if (target === "map") {
                colorSVGMap();
            }
            if (target === "rankings") {
                renderRankingsTable();
            }
            if (target === "insights") {
                renderInsightsTab();
            }
        });
    });
}

// --- 10. THEME SWITCHING CONTROLLER ---
function setupThemeToggler() {
    const btn = document.getElementById("theme-toggle-btn");
    if (!btn) return;
    
    btn.addEventListener("click", () => {
        const body = document.body;
        const isDark = body.classList.contains("dark-theme");
        
        if (isDark) {
            body.classList.remove("dark-theme");
            body.classList.add("light-theme");
            btn.innerHTML = `<i data-lucide="moon"></i>`;
        } else {
            body.classList.remove("light-theme");
            body.classList.add("dark-theme");
            btn.innerHTML = `<i data-lucide="sun"></i>`;
        }
        
        lucide.createIcons();
        
        // Update Chart ticks/grid colors dynamically
        const colors = getChartColors();
        const updateChartConfig = (chartInstance) => {
            if (!chartInstance) return;
            if (chartInstance.options.scales.x) {
                chartInstance.options.scales.x.ticks.color = colors.ticks;
            }
            if (chartInstance.options.scales.y) {
                chartInstance.options.scales.y.grid.color = colors.grid;
                chartInstance.options.scales.y.ticks.color = colors.ticks;
            }
            if (chartInstance.options.scales.r) {
                chartInstance.options.scales.r.angleLines.color = colors.grid;
                chartInstance.options.scales.r.grid.color = colors.grid;
                chartInstance.options.scales.r.pointLabels.color = colors.ticks;
            }
            if (chartInstance.options.plugins.legend) {
                chartInstance.options.plugins.legend.labels.color = colors.ticks;
            }
            chartInstance.options.plugins.tooltip.backgroundColor = colors.tooltipBg;
            chartInstance.options.plugins.tooltip.borderColor = colors.tooltipBorder;
            chartInstance.options.plugins.tooltip.titleColor = colors.tooltipText;
            chartInstance.options.plugins.tooltip.bodyColor = colors.tooltipText;
            chartInstance.update();
        };
        
        updateChartConfig(familyOverviewChart);
        updateChartConfig(phaseDistributionChart);
        updateChartConfig(stateRadarChart);
        updateChartConfig(stateLineChart);
    });
}

// --- 11. STATIC STARRY DYNAMICS ---
function generateStars() {
    const container = document.getElementById("stars-container");
    if (!container) return;
    
    container.innerHTML = "";
    
    const count = 100;
    for (let i = 0; i < count; i++) {
        const star = document.createElement("div");
        star.className = "star";
        
        // Random dimensions
        const size = Math.random() * 2;
        star.style.width = `${size}px`;
        star.style.height = `${size}px`;
        
        // Position
        star.style.left = `${Math.random() * 100}%`;
        star.style.top = `${Math.random() * 100}%`;
        
        // Dynamic twinkle duration
        star.style.animationDuration = `${2 + Math.random() * 5}s`;
        star.style.animationDelay = `${Math.random() * 5}s`;
        
        container.appendChild(star);
    }
}

// --- 12. INITIALIZATION HOOK ---
/**
 * Update the viewer select lists and sidebar counts based on active family members
 */
function updateDynamicDropdowns() {
    const select = document.getElementById("map-viewer-select");
    if (!select) return;
    
    const currentVal = select.value;
    select.innerHTML = `<option value="combined">Combined Family Average</option>`;
    
    APP_STATE.family.forEach(m => {
        const option = document.createElement("option");
        option.value = m.id;
        option.innerText = `${m.name.split(" ")[0]} (${m.relation})`;
        select.appendChild(option);
    });
    
    // Preserve selection
    if (select.querySelector(`option[value="${currentVal}"]`)) {
        select.value = currentVal;
    } else {
        select.value = "combined";
    }
    
    // Update badge in sidebar header
    const badge = document.querySelector(".sidebar-family .badge");
    if (badge) {
        badge.innerText = `${APP_STATE.family.length} Profiles`;
    }
}

document.addEventListener("DOMContentLoaded", () => {
    // 1. Generate stars in background
    generateStars();
    
    // 2. Initialize ASTRO calculations
    initEngine();
    
    // 3. Populate select lists dynamically
    updateDynamicDropdowns();
    
    // 4. Render sidebars
    renderFamilySidebar();
    bindSidebarInputListeners();
    
    // 5. Draw SVG map
    initializeSVGMap();
    
    // 6. Update stats widgets
    updateDashboardStats();
    
    // 7. Draw Dashboard charts
    initOverviewChart();
    
    // 8. Bind interactive actions
    setupTabNavigation();
    setupInsightsTabs();
    setupThemeToggler();
    setupModalTabs();
    
    // Add Member form toggles
    const addToggleBtn = document.getElementById("add-member-toggle-btn");
    const addCancelBtn = document.getElementById("add-member-cancel-btn");
    const addSaveBtn = document.getElementById("add-member-save-btn");
    const addFormCard = document.getElementById("add-member-form-card");
    const relationSelect = document.getElementById("new-member-relation");
    const customRelationWrapper = document.getElementById("new-member-custom-relation-wrapper");
    
    if (relationSelect && customRelationWrapper) {
        relationSelect.addEventListener("change", (e) => {
            if (e.target.value === "Custom") {
                customRelationWrapper.style.display = "flex";
            } else {
                customRelationWrapper.style.display = "none";
            }
        });
    }
    
    if (addToggleBtn && addFormCard) {
        addToggleBtn.addEventListener("click", () => {
            const isHidden = addFormCard.style.display === "none" || addFormCard.style.display === "";
            if (isHidden) {
                addFormCard.style.display = "block";
                addToggleBtn.innerHTML = `<i data-lucide="minus"></i> Close Form`;
                
                // Clear fields
                document.getElementById("new-member-name").value = "";
                document.getElementById("new-member-date").value = "1990-01-01";
                document.getElementById("new-member-relation").value = "Self";
                if (customRelationWrapper) customRelationWrapper.style.display = "none";
                document.getElementById("new-member-custom-relation").value = "";
            } else {
                addFormCard.style.display = "none";
                addToggleBtn.innerHTML = `<i data-lucide="plus"></i> Add Family Member`;
            }
            lucide.createIcons();
        });
    }
    
    if (addCancelBtn && addFormCard && addToggleBtn) {
        addCancelBtn.addEventListener("click", () => {
            addFormCard.style.display = "none";
            addToggleBtn.innerHTML = `<i data-lucide="plus"></i> Add Family Member`;
            lucide.createIcons();
        });
    }
    
    if (addSaveBtn && addFormCard && addToggleBtn) {
        addSaveBtn.addEventListener("click", () => {
            const nameInput = document.getElementById("new-member-name");
            const dateInput = document.getElementById("new-member-date");
            const relationInput = document.getElementById("new-member-relation");
            const customRelationInput = document.getElementById("new-member-custom-relation");
            
            const name = nameInput.value.trim();
            const date = dateInput.value;
            let relation = relationInput.value;
            if (relation === "Custom") {
                relation = customRelationInput.value.trim() || "Custom";
            }
            
            // Call engine to add member (name is optional, engine auto-generates sequential name)
            const newMember = addFamilyMember(name, date, relation);
            
            // Expand the new member
            APP_STATE.family.forEach(m => m.expanded = (m.id === newMember.id));
            
            // Close form
            addFormCard.style.display = "none";
            addToggleBtn.innerHTML = `<i data-lucide="plus"></i> Add Family Member`;
            
            // Recalculate and update all DOM widgets and charts!
            updateDynamicDropdowns();
            updateDashboardStats();
            colorSVGMap();
            renderRankingsTable();
            renderInsightsTab();
            
            updateOverviewChart();
            updatePhaseDistributionChart();
            
            renderFamilySidebar();
            lucide.createIcons();
        });
    }
    
    // rankings search
    const searchInput = document.getElementById("state-search-input");
    if (searchInput) {
        searchInput.addEventListener("input", () => renderRankingsTable());
    }
    setupTableSorting();
    
    // modal close listeners
    document.getElementById("modal-close-btn").addEventListener("click", closeStateModal);
    document.getElementById("state-modal").addEventListener("click", (e) => {
        if (e.target === document.getElementById("state-modal")) {
            closeStateModal();
        }
    });
    
    // SVG color select listener
    document.getElementById("map-viewer-select").addEventListener("change", () => colorSVGMap());
    
    // Renders secondary tab elements on load to pre-cache them
    initPhaseDistributionChart();
    renderRankingsTable();
    
    // Load lucide icons
    lucide.createIcons();
});
